import { useAuth0 } from "@auth0/auth0-react";
import { useSelector, useStore } from "react-redux";
import { store } from "../store/store";
import { defer, redirect, Outlet } from "react-router-dom";
import GAListener from "../utils/GAListener";
import {
  setCurrentPatientName,
  setCurrentIsNmsLoading,
  setCurrentIsNmsPatientLoading,
  setCurrentIsNmsTimelineLoading,
  setCurrentIsNmsPrescriptionLoading,
  setCurrentIsServiceNotesLoading,
  setCurrentStepNoNms,
  setCurrentstageNoNms,
  setCurrentNmsModel,
  setCurrentvalueNms,
  setCurrentArrayImg,
  setCurrentPatientNMSData,
  getClinicalServiceByClinicalServiceId,
  getClinicalServiceFromOrbit,
  getTitanPatient,
  getPharmacyIdForOrbitUser,
  getTimeline,
  getServiceNotes,
  getFollowUpByServiceIdAndServiceType,
  getPatientByTelephoneAndStageIndexResult,
  setCurrentIsPatientNmsTelephoneLoading,
  setCurrentResponseDTOStagesData,
  getTotalSkips,
  getPrescriptionImagesByIncomingIds,
  getTravelInformation,
  getPharmacyProducts,
  getVaccineInfo,
  setShowVaccineBasket,
  setSelectedVaccineDose,
  setCurrentFollowUpcomments,
  setCurrentTimelineElements,
} from "../dispatchers/nmsDispatchers";
import {
  showInfo,
  showError,
} from "../components/ToastedMessage/ToastedMessage";

import { logErrorWithPayload } from "../services/logService";
import {
  markLoggingOut,
  refreshAuthToken,
  setAuthTokenProvider,
} from "../services/authToken";
import { genderTypes } from "../enum/genderTypes";
import {
  getPrescriptionIncomingIds,
  getPrescriptionByIncomingId,
  getAutomationSummary,
  getPatientMedication,
  getPrescriptionItemCheck,
  getPrescriptionChecks,
  getPatientImage,
  setPatientImage,
  setCCOrderItemToolTip,
  setIsPrescriptionItemToolTip,
  getKanbanInbox,
  getKanbanCheck,
  setIsCCKanbanLoading,
  getTitanPatientByPatientId,
  setCurrentPatientData,
  setisAccepted,
  setCurrentPatientHistory,
  getPatientHistory,
  setNewPatientId,
} from "../dispatchers/clinicalChecksDispatchers";

import {
  setAppLoading,
  setTabLoading,
  setCurrentPharmacy,
  setCurrentTeam,
  getApplicationData,
  removeAuth,
  setAuth,
  setPharmacies,
  getCompanyNames,
  updateLastLoginByEmail,
  updateLogoutByEmail,
  updateUserCurrentStatus,
  setisAgencyUser,
  getIntercomDetail,
  setisPatientSearched,
  setPatientInfoTab,
  getDemDxDetail,
  setCompanyId,
} from "../dispatchers/appDispatchers";
import {
  getPharmacyClinicalServices,
  getPharmacyClinicalServicesCount,
  getPharmacyServices,
  getNHSEmergencyService,
  setPharmacyServiceLoading,
  setCurrentServiceData,
  setCurrentNHSCount,
  setCurrentPrivateCount,
  setServiceTab,
  setShowCalender,
  getPharmaciesByCompanyId,
  setPharmacyServiceSidebarLoading,
  setPharmacyServicesAnalyticsLoading,
  getIdentityVerification,
  getPharmacyActions,
  getAgencyPharmacy,
  setCurrentTotalServicesCount,
  setCurrentCompletedService,
  getEvents,
  getDoseShortCodeList,
  getDefaultCompanyServices,
  setYotiSuccess,
  setShowNHS111ReferralTab,
  getDefaultServicesByCompanyIdAndPharmacyId,
} from "../dispatchers/pharmacyServiceDispatchers";
import {
  getDocumentRoles,
  getPermissions,
  getRoles,
  getTeamsRoleById,
  getTeamsRoles,
  setTeamLoading,
} from "../dispatchers/teamDispatchers";
import {
  getOrbitProfile,
  setCurrentOrbitLoading,
  getOrbitFollowUpServices,
  getOrbitPotentialEarnings,
  getOrbitOtherDetails,
  getOrbitUserSessions,
  getOrbitParkedServices,
  getOrbitMonthlyReport,
  getOrbitEarnings,
  setIsMonthlyReportLoading,
  setIsOrbitEarningLoading,
  setIsUserSessionLoading,
  setIsPotentialEarningLoading,
  setIsFollowupLoading,
  setIsOtherDetailsLoading,
  setIsActiveServicesLoading,
  getOrbitActiveServices,
  addOrbitSession,
  setCurrentTotalPrice,
  setCurrentOrbitAnimation,
  setCurrentTimeActive,
  getPaymentDetails,
  getOrbitTeamByCompanyId,
  getOrbitAgencyUsers,
  getOrbitAgencyDetails,
  getOrbitAgencyOtherDetails,
  getOrbitAgencyPharmacies,
  getOrbitAgencyOtherPharmacies,
  getOrbitAgencyMonthlyReport,
  getOrbitServicesWorkPlanner,
  getOrbitPharmanautsWorkPlanner,
  getOrbitWorkPlanner,
  getOthersAvailable,
  setCurrentTotalCount,
  getOrbitLiveNms,
} from "../dispatchers/orbitDispatchers";

import {
  getAllGenerals,
  setGeneralLoading,
} from "../dispatchers/generalDispatchers";
import {
  getBillingContact,
  setBillingLoading,
} from "../dispatchers/billingDispatchers";
import setServiceNms from "../Model/Nms/setServiceNms";
import setPrescriptionItemChecks from "../Model/PrescriptionItemChecks/setPrescriptionItemChecks";
import setPrescriptionChecks from "../Model/PrescriptionChecks/setPrescriptionChecks";

import {
  getAiTemplateByCompanyId,
  getAllTemplates,
  getEmailsAndSmsTemplates,
  getPreConsultTemplateByCompanyId,
  setAiqa,
  setFullTranscript,
  setHydratedTemplateSections,
  setIsTemplateSelected,
  setSelectedTemplate,
  setSelectedTemplateContent,
  setStreamedText,
  setTemplatesLoading,
  setTranscriptionState,
} from "../dispatchers/templateDispatchers";

import {
  setMemberLoading,
  getmembers,
  getServices,
  getMemberById,
  getOrbitAgencyServicesByCompanyId,
} from "../dispatchers/memberDispatchers";

import {
  getServiceTypeById,
  getServicesTypes,
  setCurrentType,
  getServicesByCompany,
} from "../dispatchers/typeDispatchers";

import { getServicesByPharmacyId } from "../dispatchers/locationDispatchers";
import {
  getAllConsentData,
  setConsentLoading,
} from "../dispatchers/consentDispatchers";
import {
  getUser,
  getEmailByInvitationCode,
  getUserForOrbit,
  setSignupForm,
  setYotiSteps,
  setProcessingApp,
  setEmailVerification,
  setOnboardingSuccess,
  getUserCertificate,
  getInviteMemberLogs,
} from "../dispatchers/onboardingVerificationDsipatchers";
import { stageTypes } from "../enum/stageType";
import moment from "moment";
import setAddSession from "../Model/Orbit/setAddSession";
import { setResponseDTOStagesData } from "../features/NmsServiceSlice/NmsServiceSlice";
import { element } from "prop-types";

import { checkUserPermissions } from "../utils/checkUserPermissions";
import {
  checkRefreshStatusTimeDifference,
  accessAgencyUser,
  accessBetaUser,
  accessOwner,
  siteName,
} from "../data/constantStrings";
import setCCToolTipData from "../Model/ClinicalChecksToolTip/setCCToolTipData";
import { setisHasDispensingWindow } from "../features/clinicalChecksSlice/clinicalChecksSlice";
import {
  getResources,
  getAllPharmacists,
  getScheduleEvents,
  setBookingSlotsMode,
  setEventsLoading,
  getGoogleEvents,
  getAllUserWeekAvailability,
  getUserDefaultCalendarView,
  getScheduleEventsByPharmacies,
} from "../dispatchers/scheduleEventsDispatchers";

import {
  getPatientAllergies,
  getPatientConditionRelated,
  getPatientConsultations,
  getPatientMedications,
  getPatientVitals,
  setSelectedPatientId,
  setSelectedPharmacyId,
  getAllCompany,
  setPatientSummary,
  setpatientCurrentSummaryArray,
  setpatientSummaryArray,
  setSecondPatientPanelTitle,
  setFirstPatientPanelTitle,
  setChatQuestions,
  setTogglePatientPanelTwo,
  setTogglePatientPanelOne,
  setPatientAIChatMessages,
  setChatBotReferralLetter,
  setPatientChatAnswersLoader,
  setIsChatReferralLetter,
  setConsultationId,
  setPatientTabSwitcher,
  generateDemDXAssessments,
  setIsSummaryGenerated,
  setReferralLetter,
  getPatientAppointmentsByPatientId,
  getPaymentAnalyticsByPatientId,
  getPatientByPatientId,
  setIsPatientDashboard,
  setIsConsultationEnabled,
  setSelectedPatientConsultation,
  setIsDemDXTemplate,
  setIsDemDxActive,
  setDemDxSummary,
  GetPatientVitalsSummaryByPatientId,
  setTranscript,
  setDemDxSummaryText,
  setIsLocallyCompleted,
  setConsultationPaused,
  setIsFinalSummary,
  getPatientDocuments,
  getPatientConsultationByConsultationId,
  getPatientPrescriptionsByPatientId,
  setConsultationAuditTimeline,
  getPatientActiveConsultation,
  setPreConsultationTemplate,
  getPatientQuestionnairesByPatientyId,
  setIsPatientDetailsLoading,
  setVaccineDetails,
  setIncrementVaccineCompleted,
  getPatientsListV2,
  setIncrementPrescriptionCompleted,
  setPrescriptionDetails,
  setIncrementReferralCompleted,
  setIncrementBookingCompleted,
  setIncrementVitalsCompleted,
  setVitalsDetails,
  setIncrementSignatureCompleted,
  setSignatureDetails,
  setIncrementPaymentCompleted,
  setLetterDetails,
  setPaymentAudit,
  setPreConsult,
  setPreConsultationTranscription,
  setBookingDetails,
  getPatientVaccinationByPatientId,
  setIsSummaryStreaming,
  setSelectedPatientDetails,
  setisManualSubmited,
  setIncrementImageDocCompleted,
  setPatientConsultations,
  setIncrementTreatmentPlanCompleted,
  setAddPatientAIChatMessage,
  setQuickActionsTabSwitch,
  setisConsultationDataLoading,
  setAccessRecord,
} from "../dispatchers/patientDispatchers";
import { getPatientActiveTreatmentPlan } from "../dispatchers/treatmentPlanDispatchers";
import { setIsPatientListLoaderData } from "../features/patientSlice/patientSlice";
import TitanScreen from "../components/TitanScreen/TitanScreen";
import {
  getCompanyDocumentsByCompanyId,
  setIsCompanyDocumentLoading,
} from "../dispatchers/companyDocumentsDispatchers";
import { getPatientPrescriptions } from "../dispatchers/patientPrescriptionDispatcher";
import { fetchServicesTab } from "../dispatchers/analyticsDispatchers";
import {
  getPharmacyDashboard,
  getScheduleEventsByUser,
  setPharmacyDashboardLoading,
  getActiveConsultationsByUser,
  getPharmacyNotifications,
} from "../dispatchers/pharmacyDashboardDispatchers";
import {
  setIsRefreshAvailable,
  getPharmacyMetricThresholdByCompanyId,
} from "../dispatchers/dashboardKPIDispatchers";
import {
  getCompanyProductRulesByCompanyId,
  setTitanTabLoading,
  getDashboardStats,
} from "../dispatchers/titanTabDispatchers";
import Intercom from "@intercom/messenger-js-sdk";
import config from "../config";
import { lazy, Suspense, useState, useEffect } from "react";

const { intercomMessengerId, intercomMessengerRegion } = config;

// ─── Lazy-loaded route components ──────────────────────────────────────────────
// Splitting here means Vite only fetches a page's JS when that route is first
// visited — instead of bundling every page into the initial load.
const NotFound = lazy(() => import("../components/NotFound/NotFound"));
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const MultiBranchDashboard = lazy(() =>
  import("../pages/MultiBranchDashboard/MultiBranchDashboard"),
);
const ClinicalChecks = lazy(() =>
  import("../pages/ClinicalChecks/ClinicalChecks"),
);
const PatientForm = lazy(() => import("../pages/PatientForm/PatientForm"));
const NmsIntervention = lazy(() =>
  import("../pages/NmsIntervention/NmsIntervention"),
);
const ClinicalServices = lazy(() =>
  import("../pages/ClinicalServices/ClinicalServices"),
);
const PharmacyServices = lazy(() =>
  import("../pages/PharmacyServices/PharmacyServices"),
);
const PharmacyOverview = lazy(() =>
  import("../pages/PharmacyOverview/PharmacyOverview"),
);
const PharmacyPatient = lazy(() =>
  import("../pages/PharmacyPatient/PharmacyPatient"),
);
const Orbit = lazy(() => import("../pages/Orbit/Orbit"));
const PatientDashboard = lazy(() =>
  import("../components/PatientDashboard/PatientDashboard"),
);
const General = lazy(() =>
  import("../components/SettingsOptions/General/General"),
);
const Locations = lazy(() =>
  import("../components/SettingsOptions/Locations/Locations"),
);
const Billing = lazy(() =>
  import("../components/SettingsOptions/Billing/Billing"),
);
const Teams = lazy(() => import("../components/SettingsOptions/Teams/Teams"));
const Services = lazy(() =>
  import("../components/SettingsOptions/Services/Services"),
);
const Templates = lazy(() =>
  import("../components/SettingsOptions/Templates/Templates"),
);
const Members = lazy(() =>
  import("../components/SettingsOptions/Teams/components/Members/Members"),
);
const Roles = lazy(() =>
  import("../components/SettingsOptions/Teams/components/Roles/Roles"),
);
const CustomTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/Templates/components/Consultation/CustomTemplate"
  ),
);
const Types = lazy(() =>
  import("../components/SettingsOptions/Services/components/Types/Types"),
);
const MembersAddNew = lazy(() =>
  import(
    "../components/SettingsOptions/Teams/components/Members/components/MembersAddNew/MembersAddNew"
  ),
);
const MembersUpdate = lazy(() =>
  import(
    "../components/SettingsOptions/Teams/components/Members/components/MembersUpdate/MembersUpdate"
  ),
);
const LocationsAddNew = lazy(() =>
  import("../components/SettingsOptions/Locations/components/LocationsAddNew"),
);
const LocationsUpdate = lazy(() =>
  import("../components/SettingsOptions/Locations/components/LocationsUpdate"),
);
const Success = lazy(() => import("../pages/UserOnboarding/Success"));
const Failure = lazy(() => import("../pages/UserOnboarding/Failure"));
const VerificationEmail = lazy(() =>
  import("../pages/UserOnboarding/VerificationEmail"),
);
const UpdateRole = lazy(() =>
  import(
    "../components/SettingsOptions/Teams/components/Roles/components/RolesAddNew/UpdateRole"
  ),
);
const RolesAddNew = lazy(() =>
  import(
    "../components/SettingsOptions/Teams/components/Roles/components/RolesAddNew/RolesAddNew"
  ),
);
const NmsConsent = lazy(() => import("../pages/NmsConsent/NmsConsent"));
const NewMedicineService = lazy(() =>
  import("../pages/NmsConsent/components/NewMedicineService"),
);
const Abort = lazy(() => import("../pages/NmsConsent/components/Abort"));
const MoreInfo = lazy(() => import("../pages/NmsConsent/components/MoreInfo"));
const PersonalInfo = lazy(() =>
  import("../pages/NmsConsent/components/PersonalInfo"),
);
const MakeBooking = lazy(() =>
  import("../pages/NmsConsent/components/MakeBooking"),
);
const SuccessPage = lazy(() =>
  import("../pages/NmsConsent/components/SuccessPage"),
);
const ProfessionalDetails = lazy(() =>
  import("../components/OrbitSettings/ProfessionalDetails/ProfessionalDetails"),
);
const ComplianceDocuments = lazy(() =>
  import("../components/OrbitSettings/ComplianceDocuments/ComplianceDocuments"),
);
const AddNewCustomTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/Templates/components/Consultation/AddNewCustomTemplate"
  ),
);
const Availability = lazy(() =>
  import("../components/OrbitSettings/Availability/Availability"),
);
const ChangePassword = lazy(() =>
  import("../components/OrbitSettings/ChangePassword/ChangePassword"),
);
const PaymentDetails = lazy(() =>
  import("../components/OrbitSettings/PaymentDetails/PaymentDetails"),
);
const AccreditationsSkills = lazy(() =>
  import(
    "../components/OrbitSettings/AccreditationsSkills/AccreditationsSkills"
  ),
);
const TypesUpdate = lazy(() =>
  import(
    "../components/SettingsOptions/Services/components/Types/components/TypesUpdate/TypesUpdate"
  ),
);
const TypesAddNew = lazy(() =>
  import(
    "../components/SettingsOptions/Services/components/Types/components/TypesAddNew/TypesAddNew"
  ),
);
const OnboardingVerification = lazy(() =>
  import("../components/OnboardingVerification/OnboardingVerification"),
);
const InviteMembers = lazy(() =>
  import("../components/InviteMembers/InviteMembers"),
);
const UserSignup = lazy(() => import("../components/UserSignup/UserSignup"));
const OnboardingResetPassword = lazy(() =>
  import("../components/OnboardingResetPassword/OnboardingResetPassword"),
);
const SelectionScreen = lazy(() =>
  import("../components/SettingsOptions/SelectionScreen/SelectionScreen"),
);
const DifferentOrganization = lazy(() =>
  import("../components/DifferentOrganization/DifferentOrganization"),
);
const ServiceTypes = lazy(() =>
  import(
    "../components/SettingsOptions/Services/components/Types/ServiceTypes"
  ),
);
const EmailAndSms = lazy(() =>
  import("../components/SettingsOptions/EmailAndSms/EmailAndSms"),
);
const UpdateEmailTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/EmailAndSms/component/UpdateEmailTemplate"
  ),
);
const AddTemplate = lazy(() =>
  import("../components/SettingsOptions/EmailAndSms/component/AddTemplate"),
);
const PrivateService = lazy(() =>
  import("../pages/PrivateService/PrivateService"),
);
const SignUp = lazy(() => import("../pages/Dashboard/SignUp"));
const ConsultationForm = lazy(() =>
  import("../pages/PrivateService/components/components/ConsultationForm"),
);
import GlobalTabbedContentView from "../components/GlobalTabbedContentView/GlobalTabbedContentView";
const PharmacyOverviewPanel = lazy(() =>
  import("../components/PharmacyOverviewPanel/PharmacyOverviewPanel"),
);
const PharmacyServicesPanel = lazy(() =>
  import("../components/PharmacyServicesPanel/PharmacyServicesPanel"),
);
const ServicesSchedule = lazy(() =>
  import(
    "../pages/Dashboard/ServicesTab/ServicesContainer/ServicesSchedule/ServicesSchedule"
  ),
);
const ServicesWorkLoad = lazy(() =>
  import(
    "../pages/Dashboard/ServicesTab/ServicesContainer/ServicesWorkLoad/WorkLoad/ServicesWorkLoad"
  ),
);
const ClinicalChecksKanban = lazy(() =>
  import(
    "../pages/Dashboard/ServicesTab/ServicesContainer/ClinicalChecksKanban/ClinicalChecksKanban"
  ),
);
const SchedulerComponent = lazy(() =>
  import("../components/Scheduler/Schedule"),
);
const ScheduleCalendar = lazy(() => import("../components/Calendar/Schedule"));
const ServiceConsultation = lazy(() =>
  import("../components/ServiceConsultation/ServiceConsultation"),
);
const Consultation = lazy(() => import("../pages/Consultation/Consultation"));
const PatientConsultation = lazy(() =>
  import("../components/PatientConsultation/PatientConsultation"),
);
const AddNewAiCustomTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/Templates/components/Consultation/AddNewAiCustomTemplate"
  ),
);
const CustomAiTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/Templates/components/Consultation/CustomAiTemplate"
  ),
);
const UpdateAiCustomTemplate = lazy(() =>
  import(
    "../components/SettingsOptions/Templates/components/Consultation/UpdateAiCustomTemplate"
  ),
);
const PatientList = lazy(() =>
  import(
    "../components/PatientConsultation/components/PatientList/PatientList"
  ),
);
const PrescriptionApproval = lazy(() =>
  import(
    "../components/PrescriptionApproval/PrescriptionApproval"
  ).then((m) => ({ default: m.PrescriptionApproval })),
);
import { PatientDashboardV2 } from "../components/PatientDashboardV2/PatientDashboardV2";
import Login from "@/pages/Dashboard/Login";
const PharmacyDashboard = lazy(() =>
  import("../components/PharmacyDashboard/Dashboard"),
);
const Documents = lazy(() => import("../components/Documents/Documents"));
const Analytics = lazy(() => import("../components/Analytics/Analytics"));
// ───────────────────────────────────────────────────────────────────────────────

// Resolves once Auth0 has finished its initial load (callback exchange or
// session check). Loaders await this before calling getAccessTokenSilently()
// so they never race against the callback on browsers with strict tracking
// prevention (e.g. Edge Strict mode) where the silent iframe is blocked.
let _authReadyResolve = null;
const _authReadyPromise = new Promise((resolve) => {
  _authReadyResolve = resolve;
});

export const useTitanApp = () => {
  // #region Hook Constants
  const store = useStore();
  const auth = useAuth0();
  const appState = useSelector((state) => state.app);
  const pharmacyServiceState = useSelector((state) => state.pharmacyService);
  const nmsServiceState = useSelector((state) => state.nmsService);
  const documentState = useSelector((state) => state.documentService);
  const { loginWithRedirect, getAccessTokenSilently, logout, user } =
    auth || {};
  const clincicalChecksState = useSelector((state) => state.clinicalChecks);
  const orbitState = useSelector((state) => state.orbit);
  const consentState = useSelector((state) => state.consent);
  const locationState = useSelector((state) => state.location);
  const generalsState = useSelector((state) => state.general);
  const memberState = useSelector((state) => state.member);
  const billingState = useSelector((state) => state.billing);
  const reportingState = useSelector((state) => state.reporting);
  const onboardingVerificationState = useSelector(
    (state) => state.onboardingVerification,
  );
  const scheduleEventState = useSelector((state) => state.scheduleEvent);
  const patientState = useSelector((state) => state.patient);
  const templateState = useSelector((state) => state.template);
  const marketAppState = useSelector((state) => state.marketApp);
  const patientPrescriptionState = useSelector(
    (state) => state.patientPrescription,
  );
  const companyDocumentState = useSelector((state) => state.companyDocument);
  const companyServiceBillingState = useSelector(
    (state) => state.companyServiceBilling,
  );
  const patientCommunicationState = useSelector(
    (state) => state.patientCommunication,
  );
  const analyticsState = useSelector((state) => state.analytics);
  const pharmacyDashboardState = useSelector(
    (state) => state.pharmacyDashboard,
  );
  const pharmacyNotificationsState = useSelector(
    (state) => state.pharmacyNotifications,
  );
  const dosState = useSelector((state) => state.dos);
  const treatmentPlanState = useSelector((state) => state.treatmentPlan);
  const dashboardKPIState = useSelector((state) => state.dashboardKPI);
  const titanTabState = useSelector((state) => state.titanTab);

  const mysClaimsState = useSelector((state) => state.mysClaims);
  const FeatureSearchTypes = {
    All: 0,
    Enabled: 1,
    Disabled: 2,
    AllByCompanyId: 3,
    EnabledByCompanyId: 4,
    DisabledBycompanyId: 5,
    Minimal: 6,
    MinimalWithKpis: 7,
    MinimalWithPatients: 8,
  };

  // #endregion

  // #region API getter/caller functions for components usage to dispatch REDUX extra reducers

  if (!useTitanApp._authProviderSet) {
    setAuthTokenProvider(async () => {
      let newAuthToken = "";

      // Wait for Auth0 to finish its initial load before asking for a token.
      // Without this, the loader races against Auth0's useEffect callback
      // processing on browsers with strict tracking prevention (Edge Strict),
      // causing getAccessTokenSilently() to fail and loop.
      await _authReadyPromise;

      try {
        newAuthToken = await getAccessTokenSilently();
      } catch (error) {
        if (
          error?.error === "login_required" ||
          // consent_required: user must explicitly consent to the API audience;
          // redirect through the full login flow so the consent screen appears.
          error?.error === "consent_required"
        ) {
          localStorage.setItem("loginRequired", true);
          removeAuth();
          showInfo("Loading...", false);
          setTimeout(
            (loginWithRedirect) => {
              loginWithRedirect();
            },
            100,
            loginWithRedirect,
          );
        } else {
          logErrorWithPayload(
            error?.error || "You are unauthorized or blocked...",
          );
          showError(error?.error || "You are unauthorized or blocked...");
        }
      }

      setAuth(newAuthToken);
      return newAuthToken;
    });
    useTitanApp._authProviderSet = true;
  }

  // Resolve _authReadyPromise once Auth0 finishes its initial load so that
  // the authTokenProvider stops waiting and proceeds to getAccessTokenSilently.
  useEffect(() => {
    if (!auth.isLoading && _authReadyResolve) {
      _authReadyResolve();
      _authReadyResolve = null;
    }
  }, [auth.isLoading]);

  const getAuthToken = async () => {
    return await refreshAuthToken();
  };
  // #endregion

  // #region Loader Handlers
  const onDashboardLoaded = () => {
    const currentAppState = store.getState().app;
    let redirectTo = null;
    const { isValidOrg, companyId, currentPharmacyId, features, isOrbitUser } =
      currentAppState || {};

    if (isOrbitUser === true) {
      redirectTo = new redirect(`/orbit`);
    } else if (isValidOrg === true) {
      const { ifMapEnabled, ifPatientListEnabled, ifPharmacyDashboardEnabled } =
        features || {};

      if (ifMapEnabled === false) {
        if (ifPharmacyDashboardEnabled === true) {
          redirectTo = new redirect(`/pharmacy/overview/${currentPharmacyId}`);
        } else if (ifPatientListEnabled === true) {
          redirectTo = new redirect(`/pharmacypatient/${currentPharmacyId}`);
        } else {
          redirectTo = new redirect(`/pharmacy/services/${currentPharmacyId}`);
        }
      }
    } else {
      const { hasNoTeams } = currentAppState || {};
      if (!hasNoTeams) {
        redirectTo = new redirect(`/invitemembers`);
      }
    }
    // else {
    //   // if (!companyId) {
    //   //   showError("Company not found or not associated with you account.");
    //   // } else if (
    //   //   !currentPharmacyId ||
    //   //   currentPharmacyId === "00000000-0000-0000-0000-000000000000"
    //   // ) {
    //   //   showError("Pharmacy not found or not associated with you account.");
    //   // }
    //   // throw new Error("Invalid org or company or pharmacy not found.");
    // }
    return redirectTo;
  };

  const onVerificationLoaded = (invitationCode) => {
    const currentAppState = store.getState().app;
    const { authToken } = currentAppState || {} || {};
    let redirectTo = null;
    if (authToken !== "") {
      redirectTo = new redirect(`/usersignup/${invitationCode}`);
    }
    return redirectTo;
  };

  const onSelectionScreenLoaded = () => {
    let redirectTo = null;
    const storedOption = localStorage.getItem("selectedOption");
    if (storedOption === "orbit") {
      redirectTo = new redirect(`/orbit`);
    } else if (storedOption === "dashboard") {
      redirectTo = null;
    } else {
      redirectTo = new redirect(`/selectionScreen`);
    }
    return redirectTo;
  };

  const onCompanySelectionLoaded = () => {
    const hasRedirected = localStorage.getItem("companySelectionRedirected");
    if (hasRedirected !== "true") {
      return null;
    }
    return new redirect(`/companyselection`);
  };

  const onOrbitLoaded = () => {
    let redirectTo = null;
    redirectTo = new redirect("/");
    return redirectTo;
  };

  const onPharmacyOverviewLoaded = () => {
    const currentAppState = store.getState().app;
    let redirectTo = null;
    const { isValidOrg, companyId, currentPharmacyId, features } =
      currentAppState || {};
    if (isValidOrg === true) {
      const { ifPatientListEnabled, ifPharmacyDashboardEnabled } =
        features || {};

      if (ifPharmacyDashboardEnabled === false) {
        if (ifPatientListEnabled === true) {
          redirectTo = new redirect(`/pharmacypatient/${currentPharmacyId}`);
        } else {
          redirectTo = new redirect(`/pharmacy/services/${currentPharmacyId}`);
        }
      }
    } else {
      if (!companyId) {
        showError("Company not found or not associated with you account.");
      } else if (
        !currentPharmacyId ||
        currentPharmacyId === "00000000-0000-0000-0000-000000000000"
      ) {
        showError("Pharmacy not found or not associated with you account.");
      }
      throw new Error("Invalid org or company or pharmacy not found.");
    }

    return redirectTo;
  };

  const onPharmacyPatientLoaded = () => {
    const currentAppState = store.getState().app;
    let redirectTo = null;
    const { isValidOrg, companyId, currentPharmacyId, features } =
      currentAppState || {};
    if (isValidOrg === true) {
      const { ifPatientListEnabled } = features || {};

      if (ifPatientListEnabled === false) {
        redirectTo = new redirect(`/pharmacy/services/${currentPharmacyId}`);
      }
    } else {
      if (!companyId) {
        showError("Company not found or not associated with you account.");
      } else if (
        !currentPharmacyId ||
        currentPharmacyId === "00000000-0000-0000-0000-000000000000"
      ) {
        showError("Pharmacy not found or not associated with you account.");
      }
      throw new Error("Invalid org or company or pharmacy not found.");
    }

    return redirectTo;
  };

  const onPharmacyServiceLoaded = () => {
    const currentAppState = store.getState().app;
    const { isValidOrg, companyId, currentPharmacyId } = currentAppState || {};
    if (isValidOrg === false) {
      if (!companyId) {
        showError("Company not found or not associated with you account.");
      } else if (
        !currentPharmacyId ||
        currentPharmacyId === "00000000-0000-0000-0000-000000000000"
      ) {
        showError("Pharmacy not found or not associated with you account.");
      }
      throw new Error("Invalid org or company or pharmacy not found.");
    }

    return null;
  };

  const onClinicalChecksLoaded = () => {
    const currentAppState = store.getState().app;
    const { isValidOrg, companyId, currentPharmacyId } = currentAppState || {};
    if (isValidOrg === false) {
      if (!companyId) {
        showError("Company not found or not associated with you account.");
      } else if (
        !currentPharmacyId ||
        currentPharmacyId === "00000000-0000-0000-0000-000000000000"
      ) {
        showError("Pharmacy not found or not associated with you account.");
      }
      throw new Error("Invalid org or company or pharmacy not found.");
    }

    return null;
  };

  const teamAndPharmacyHandler = (redirectTo, data, params) => {
    let result = false;
    if (redirectTo === null && data && params.pharmacyId) {
      const { teams, user } = data || {};
      let teamIndex = 0;
      if (user?.role !== null) {
        teamIndex = teams?.findIndex((team) => {
          const result = team.pharmacies?.findIndex((pharmacy) => {
            return pharmacy.teamPharmacyID === params.pharmacyId;
          });

          return result >= 0;
        });
      } else {
        teamIndex = teams?.findIndex(
          (eachTeam) => eachTeam.isGlobalView === true,
        );
        if (teamIndex === -1) {
          teamIndex = teams?.findIndex((team) => {
            const result = team.pharmacies?.findIndex(
              (pharmacy) => pharmacy.teamPharmacyID === params.pharmacyId,
            );
            return result >= 0;
          });
        }
      }
      const teamFound = teamIndex >= 0 ? teams[teamIndex] : null;
      if (teamFound) {
        setCurrentTeam(teamFound);
        const pharmacyIndex = teamFound?.pharmacies?.findIndex(
          (pharmacy) => pharmacy.teamPharmacyID === params.pharmacyId,
        );
        const pharmacyFound =
          pharmacyIndex >= 0 ? teamFound?.pharmacies[pharmacyIndex] : null;
        if (pharmacyFound) {
          setCurrentPharmacy(pharmacyFound);
          result = true;
        }
      }
      if (user?.role !== null) {
        let allPharmacies = [];
        teams?.map((team) => {
          team?.pharmacies.map((pharmacy) => {
            if (
              !allPharmacies.some(
                (phar) => phar.teamPharmacyID === pharmacy.teamPharmacyID,
              )
            ) {
              allPharmacies = [...allPharmacies, pharmacy];
            }
          });
        });
        setPharmacies(allPharmacies);
      }
    }
    return result;
  };

  const calculateServiceData = async () => {
    const currentPharmacyServiceState = store.getState().pharmacyService;

    const nhsData = currentPharmacyServiceState?.NHSEmergencyServiceData || [];
    const nhsVisibleCount = nhsData.reduce(
      (sum, col) => sum + (col.data?.length ?? 0),
      0,
    );

    const mergedNamesandCounts = currentPharmacyServiceState?.pharmacyClincalServices
      ?.map((obj1) => {
        const obj2 = currentPharmacyServiceState?.pharmacyClincalServicesCount?.find(
          (obj) => obj.serviceID === obj1.serviceID,
        );
        const merged = { ...obj1, ...obj2 };
        if (merged.serviceCode === 17 && nhsVisibleCount > 0) {
          merged.total = nhsVisibleCount;
        }
        return merged;
      })
      ?.sort((a, b) => {
        if (a.name === "New Medicine Service") return -1;
        if (b.name === "New Medicine Service") return 1;
        return 0;
      });

    setCurrentServiceData(mergedNamesandCounts);
    const NHSServicesList = mergedNamesandCounts.filter(
      (obj) => obj.serviceType === 1,
    );

    const totalNHS = NHSServicesList.reduce(
      (acc, obj) => acc + (obj.total || 0),
      0,
    );

    const privateServicesList = mergedNamesandCounts.filter(
      (obj) => obj.serviceType === 2,
    );

    const totalPrivate = privateServicesList.reduce(
      (acc, obj) => acc + (obj.total || 0),
      0,
    );

    const servicesTotal = totalNHS + totalPrivate;
    setCurrentNHSCount(totalNHS);
    setCurrentPrivateCount(totalPrivate);
    setCurrentTotalServicesCount(servicesTotal);
  };

  const setStageAndTabValues = (
    service,
    clinicalServiceType,
    clinicalServiceIdParam,
  ) => {
    let StageIndexForTab,
      stageNo = 0;
    setCurrentStepNoNms(service.stages[stageNo]?.metaDataList?.length || 0);
    const stages = service?.stages;

    for (let index = 0; index < stages?.length; index++) {
      const stage = stages[index];

      if (stage.clinicalServiceStageStatus !== 2) {
        StageIndexForTab = index;
        if (index > 1) {
          setCurrentStepNoNms(1);
        }
        setCurrentstageNoNms(index);
        break;
      }
    }
    const model = new setServiceNms(
      service,
      StageIndexForTab,
      null,
      null,
      false,
      clinicalServiceType,
      null,
      null,
      null,
      null,
      "",
      "00000000-0000-0000-0000-000000000000",
      null,
    );
    setCurrentNmsModel(model);
    if (clinicalServiceIdParam !== null) {
      setCurrentvalueNms(StageIndexForTab);
    }
  };

  const onSettingsLoaded = () => {
    const currentAppState = store.getState().app;
    let redirectTo = null;
    const { isValidOrg, companyId, currentPharmacyId, features, isOrbitUser } =
      currentAppState || {};

    if (isOrbitUser === true) {
      redirectTo = new redirect(`/orbit`);
    } else if (isValidOrg === true) {
      const {
        ifMapEnabled,
        ifPatientListEnabled,
        ifPharmacyDashboardEnabled,
        ifSettingEnabled,
        ifSettingMinimal,
      } = features || {};

      if (ifSettingEnabled === false) {
        if (ifMapEnabled === false) {
          if (ifPharmacyDashboardEnabled === true) {
            redirectTo = new redirect(
              `/pharmacy/overview/${currentPharmacyId}`,
            );
          } else if (ifPatientListEnabled === true) {
            redirectTo = new redirect(`/pharmacypatient/${currentPharmacyId}`);
          } else {
            redirectTo = new redirect(
              `/pharmacy.services/${currentPharmacyId}`,
            );
          }
        } else {
          redirectTo = new redirect("/");
        }
      } else if (ifSettingMinimal === true) {
        redirectTo = new redirect("/settings/general");
      }
    } else {
      if (!companyId) {
        showError("Company not found or not associated with you account.");
      } else if (
        !currentPharmacyId ||
        currentPharmacyId === "00000000-0000-0000-0000-000000000000"
      ) {
        showError("Pharmacy not found or not associated with you account.");
      }
      throw new Error("Invalid org or company or pharmacy not found.");
    }
    return redirectTo;
  };

  const hasPharmacistPermission = (permissions) => {
    return permissions.some(
      (permission) =>
        permission?.permissionName?.trim()?.toLowerCase() === "pharmacist",
    );
  };
  // #endregion

  // #region Loaders for APIs call
  const [accountExpired, setAccountExpired] = useState(false);
  const [accountExpiredReason, setAccountExpiredReason] = useState("");
  const dashboardLoader = async () => {
    setAppLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;
    const currentAppState = store.getState().app;
    const { intercomDetail } = currentAppState || {};
    let hasAuthToken = false;
    try {
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        return error;
      };

      const finallyHandler = () => {
        setAppLoading(false);
      };
      const appDataHandler = async (data) => {
        const { hasMultipleCompanies } = data || {};
        const hostName = window.location.hostname;
        try {
        } catch (ex) {}
        if (hostName.includes(siteName)) {
          if (checkUserPermissions(accessBetaUser)) {
            if (data != null) {
              const userData = await getUser("");
              return { userData, hasMultipleCompanies };
            } else {
              setPharmacyServiceLoading(false);
              setAppLoading(false);
            }
          }
        } else {
          if (data != null) {
            const userData = await getUser("");
            return { userData, hasMultipleCompanies };
          } else {
            setPharmacyServiceLoading(false);
            setAppLoading(false);
          }
        }
      };

      const getUserDataHandler = async (data) => {
        const { userData, hasMultipleCompanies } = data || {};
        setAppLoading(false);
        // No token (e.g. right after logout, while Auth0 redirects to login):
        // userData is undefined, which would otherwise fall through to
        // onDashboardLoaded() and flash /invitemembers before the login page.
        if (!hasAuthToken) {
          return null;
        }
        if (userData === null) {
          const redirectTo = onVerificationLoaded("orbit");
          return redirectTo;
        } else {
          const { startDate, endDate } = userData ?? {};
          if (startDate || endDate) {
            const now = new Date();

            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            const isValidStart = start && !isNaN(start.getTime());
            const isValidEnd = end && !isNaN(end.getTime());
            // The end date is a whole day (stored as midnight UTC), so access
            // lasts until the end of that day, not its first minute. Matches
            // the API's EndDate >= today check.
            const endExclusive = isValidEnd
              ? new Date(
                  Date.UTC(
                    end.getUTCFullYear(),
                    end.getUTCMonth(),
                    end.getUTCDate() + 1,
                  ),
                )
              : null;

            if (isValidStart && now < start) {
              setAccountExpired(true);
              setAccountExpiredReason("not_started");
            } else if (isValidEnd && now >= endExclusive) {
              setAccountExpired(true);
              setAccountExpiredReason("expired");
            } else {
              setAccountExpired(false);
              setAccountExpiredReason("");
            }
          }

          const { isVerified, invitationCode, newCompanyID, accountType } =
            userData || {};

          const loginRequired = localStorage.getItem("loginRequired");
          if (hasMultipleCompanies) {
            const redirectTo = onCompanySelectionLoaded();
            return redirectTo;
          }
          if (loginRequired === "true") {
            updateUserCurrentStatus(2);
            updateLastLoginByEmail()
              .then(() => {
                localStorage.setItem("loginRequired", false);
              })
              .catch((error) => {
                console.error("Error updating last login:", error);
              });
          }
          if (accountType === 3) {
            const redirectTo = onSelectionScreenLoaded();
            return redirectTo;
          }
          // if (newCompanyID !== null) {
          //   const redirectTo = new redirect(`/neworganization`);
          //   return redirectTo;
          // }
          if (isVerified === null || isVerified === false) {
            const redirectTo = onVerificationLoaded(invitationCode);
            return redirectTo;
          } else {
            const redirectTo = onDashboardLoaded();
            if (redirectTo !== null) {
              setAppLoading(true);
              return redirectTo;
            }
          }
        }

        return userData;
      };

      const integrationHandler = async (data) => {
        // If data is a redirect response from React Router, pass it through unchanged
        if (
          data &&
          typeof data === "object" &&
          data.status &&
          data.status >= 300 &&
          data.status < 400
        ) {
          return data;
        }

        try {
          const currentAppState = store.getState().app;
          const { currentUser } = currentAppState || {};
          if (currentUser !== null) {
            getDemDxDetail();
            if (intercomDetail === "") {
              var data = await getIntercomDetail();
              Intercom({
                intercom_user_jwt: data,
                app_id: intercomMessengerId,
                region: intercomMessengerRegion,
                user_id: auth?.user?.email,
                created_at: Math.floor(Date.now() / 1000),
              });
            }
          }
        } catch (ex) {}

        return data;
      };
      const pharmacyKPIHandler = async (data) => {
        // If data is a redirect response from React Router, pass it through unchanged
        if (
          data &&
          typeof data === "object" &&
          data.status &&
          data.status >= 300 &&
          data.status < 400
        ) {
          return data;
        }

        try {
          const currentAppState = store.getState().app;
          const { companyId, features } = currentAppState || {};
          const { ifDashboardKPIEnabled } = features || {};
          if (!ifDashboardKPIEnabled) {
            return data;
          }
          if (!companyId) {
            return data;
          }
          await getPharmaciesByCompanyId(companyId);
          const kpiData = await getPharmacyMetricThresholdByCompanyId(
            companyId,
          );
          // Compute the highest createdOn across all metrics
          let maxCreatedOn = null;
          (kpiData || []).forEach((pharmacy) => {
            (pharmacy.metrics ?? []).forEach((metric) => {
              if (metric.createdOn) {
                const d = new Date(metric.createdOn);
                if (
                  !isNaN(d.getTime()) &&
                  (!maxCreatedOn || d > maxCreatedOn)
                ) {
                  maxCreatedOn = d;
                }
              }
            });
          });

          if (maxCreatedOn) {
            const now = new Date();
            const diffHours =
              (now.getTime() - maxCreatedOn.getTime()) / (1000 * 60 * 60);
            const minHours = Number(checkRefreshStatusTimeDifference);
            setIsRefreshAvailable(diffHours >= minHours);
          } else {
            setIsRefreshAvailable(true);
          }
        } catch (ex) {}

        return data;
      };

      const authTokenHandler = async (authToken) => {
        hasAuthToken = !!authToken;
        if (authToken) {
          return await getApplicationData(FeatureSearchTypes.All);
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
        }
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .then(getUserDataHandler)
        .then(integrationHandler)
        .then(pharmacyKPIHandler)
        .catch(errorHandler)
        .finally(finallyHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }
    return defer({ appData });
  };

  const multiBranchDashboardLoader = async () => {
    setAppLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        try {
          const currentAppState = store.getState().app;
          const { currentCompanyId, groupModeCompanyId } =
            currentAppState || {};
          const selectedCompanyId =
            groupModeCompanyId ||
            (currentCompanyId && currentCompanyId !== ""
              ? currentCompanyId
              : data?.companyID);
          if (groupModeCompanyId) {
            setCompanyId(groupModeCompanyId);
          }
          const dashboardStats = await getDashboardStats(selectedCompanyId);
          return { data, dashboardStats };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }
      return data;
    };

    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const signupLoader = async ({ params }) => {
    setAppLoading(true);
    let appData = null;
    try {
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        return error;
      };
      const finallyHandler = () => {
        setAppLoading(false);
      };
      const appDataHandler = async () => {
        // if (params.code === "orbit") {
        //   return await getUserForOrbit();
        // } else {
        //   return await getEmailByInvitationCode(params.code);
        // }
        const invitationCode = await getEmailByInvitationCode(params.code);

        return { invitationCode };
      };
      const userSignUpHandler = async () => {
        const currentonboardingVerificationState = store.getState()
          .onboardingVerification;
        const { userData } = currentonboardingVerificationState;
        if (userData?.isVerified === false) {
          if (userData?.firstName === "") {
            setSignupForm(true);
          } else {
            if (userData?.role !== null) {
              if (
                userData?.role?.roleName?.trim()?.toLowerCase() === "pharmacist"
              ) {
                setSignupForm(false);
                setYotiSteps(false);
                setYotiSuccess(true);
                setProcessingApp(true);
                setEmailVerification(false);
              } else {
                setSignupForm(false);
                setOnboardingSuccess(true);
              }
            } else {
              setSignupForm(false);
              setOnboardingSuccess(true);
            }
          }
        } else if (
          userData?.newCompanyID !== null ||
          userData?.newCompanyID !== ""
        ) {
          setSignupForm(true);
        }
      };

      appData = appDataHandler()
        .then(userSignUpHandler)
        .catch(errorHandler)
        .finally(finallyHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }
    return defer({ appData });
  };
  const companySelectionLoader = async () => {
    setAppLoading(true);
    let appData = null;
    try {
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        return error;
      };
      const finallyHandler = () => {
        setAppLoading(false);
      };
      const appDataHandler = async () => {
        await getApplicationData();
        await getInviteMemberLogs();
        return;
      };

      appData = appDataHandler()
        .catch(errorHandler)
        .finally(finallyHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }
    return defer({ appData });
  };

  const multipleInviteLoader = async ({ params }) => {
    if (params?.IsMultipleInvite === "true") {
      await signout();
      localStorage.setItem("companySelectionRedirected", "true");
      return redirect("/");
    }

    setAppLoading(true);
    let appData = null;
    try {
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        return error;
      };
      const finallyHandler = () => {
        setAppLoading(false);
      };
      const appDataHandler = async () => {
        const inviteMemberLogs = await getInviteMemberLogs();
        return { inviteMemberLogs };
      };

      appData = appDataHandler()
        .catch(errorHandler)
        .finally(finallyHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }
    return defer({ appData });
  };

  const pharmacyOverviewTabLoader = async ({ params }) => {
    setTabLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;
    try {
      const appDataHandler = (data) => {
        const redirectTo = onPharmacyOverviewLoaded();
        setCurrentTeam(null);
        setCurrentPharmacy(null);
        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          redirectTo,
          data,
          params,
        );
        isteamAndPharmacyHandled === true && setAppLoading(false);
        setTabLoading(false);

        return redirectTo !== null ? redirectTo : data;
      };

      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData(FeatureSearchTypes.MinimalWithKpis);
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
          setTabLoading(false);
        }
        return null;
      };
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };
      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
      setTabLoading(false);
    }

    return defer({ appData });
  };

  const pharmacyPatientTabLoader = async ({ params }) => {
    setTabLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;
    try {
      const appDataHandler = (data) => {
        const redirectTo = onPharmacyPatientLoaded();
        setCurrentTeam(null);
        setCurrentPharmacy(null);
        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          redirectTo,
          data,
          params,
        );
        isteamAndPharmacyHandled === true && setAppLoading(false);
        setTabLoading(false);
        return redirectTo !== null ? redirectTo : data;
      };

      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData(FeatureSearchTypes.MinimalWithPatients);
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
          setTabLoading(false);
        }
        return null;
      };
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };
      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
      setTabLoading(false);
    }

    return defer({ appData });
  };

  const pharmacyServicesTabLoader = async ({ params }) => {
    setTabLoading(true);
    setPharmacyServiceLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setPharmacyServiceSidebarLoading(true);
    setPharmacyServicesAnalyticsLoading(true);
    const currentPharmacyServiceState = store.getState().pharmacyService;
    const currentAppState = store.getState().app;
    const { currentPharmacyId } = currentAppState || {};
    const { currentServiceId, currentServiceTab } =
      currentPharmacyServiceState || {};
    if (currentServiceTab === 2) {
      setCurrentCompletedService("1");
      await getEvents(currentPharmacyId, currentServiceId);
    }
    setServiceTab(0);
    setShowCalender(false);
    let appData = null;
    try {
      const appDataHandler = (data) => {
        let result = null;
        const redirectTo = onPharmacyServiceLoaded();
        setCurrentTeam(null);
        setCurrentPharmacy(null);

        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          redirectTo,
          data,
          params,
        );
        if (isteamAndPharmacyHandled === true) {
          result = getServiceData(params.pharmacyId);
        }

        return redirectTo !== null ? redirectTo : result;
      };

      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
          setTabLoading(false);
        }
        return null;
      };

      const pharmacyServiceHandler = (data) => {
        setAppLoading(false);
        setTabLoading(false);
        return data;
      };

      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setPharmacyServiceLoading(false);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };
      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .then(pharmacyServiceHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setPharmacyServiceLoading(false);
      setAppLoading(false);
      setTabLoading(false);
    }

    return defer({ appData });
  };

  const clinicalCheckTabLoader = async ({ params }) => {
    setIsCCKanbanLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;

    try {
      const appDataHandler = async (data) => {
        let result = null;
        const redirectTo = onPharmacyServiceLoaded();
        setCurrentTeam(null);
        setCurrentPharmacy(null);

        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          redirectTo,
          data,
          params,
        );
        if (isteamAndPharmacyHandled === true) {
          const [kanbanInbox, kanbanCheck] = await Promise.all([
            getKanbanInbox(params.pharmacyId),
            getKanbanCheck(params.pharmacyId),
          ]);

          return { kanbanInbox, kanbanCheck };
        }

        return redirectTo !== null ? redirectTo : result;
      };

      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
          setIsCCKanbanLoading(false);
        }
        return null;
      };
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setIsCCKanbanLoading(false);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setIsCCKanbanLoading(false);
    }

    return defer({ appData });
  };

  const getServiceData = async (pharmacyId) => {
    const currentPharmacyServiceState = store.getState().pharmacyService;
    const { currentServiceId } = currentPharmacyServiceState || {};
    var pharmacyClinicalService = await getPharmacyClinicalServices(pharmacyId);
    var pharmacyAction = await getPharmacyActions(pharmacyId);
    var pharmacyCount = await getPharmacyClinicalServicesCount(pharmacyId);
    // var pharmacyAgency = await getAgencyPharmacy(pharmacyId);
    getDoseShortCodeList(pharmacyId);
    await getNHSEmergencyService(pharmacyId);
    await calculateServiceData();
    var pharmacyServices = await getPharmacyServices(
      pharmacyId,
      0,
      currentServiceId ? currentServiceId : 0,
      false,
    );
    return pharmacyServices;
  };

  const getClinicalChecksLoader = async ({ params }) => {
    setAppLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;

    try {
      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
        }
        return null;
      };

      const appDataHandler = (data) => {
        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          null,
          data,
          params,
        );
        const currentAppState = store.getState().app;
        const { currentPharmacyId, currentTeamId } = currentAppState || {};

        const pharmacyId =
          params?.pharmacyId === "00000000-0000-0000-0000-000000000000"
            ? currentPharmacyId
            : params?.pharmacyId;
        const incomingId = params?.incomingId;
        return getClinicalChecksResult(incomingId, pharmacyId);
      };

      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        return error;
      };
      appData = getAuthToken()
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }

    return defer({ appData });
  };

  const getClinicalChecksResult = async (
    prescriptionIncomingId,
    pharmacyID,
  ) => {
    const prescriptionData = await getPrescriptionDataByIncomingId(
      prescriptionIncomingId,
      pharmacyID,
    );
    setPatientImage([]);
    const prescriptionGetModel = prescriptionData?.prescriptionGetModel;
    const patientId = prescriptionGetModel?.patientId;
    const hasPatient =
      patientId !== null && patientId !== "00000000-0000-0000-0000-000000000000";
    let itemChecksRequest = null;

    if (
      prescriptionData &&
      prescriptionIncomingId != null &&
      prescriptionGetModel != null
    ) {
      // Reset state before firing the requests that repopulate it
      setisHasDispensingWindow(false);
      setisAccepted(false);
      setIsPrescriptionItemToolTip([]);
      setCurrentPatientData(null);
      setNewPatientId("");
      setCurrentPatientHistory([]);

      // Only the item checks (right section) block the page loader. Every
      // other request runs in the background with its own loader flag.
      itemChecksRequest = getPrescriptionItemCheckData(prescriptionIncomingId);
      itemChecksRequest.then(() =>
        loadCCOrderItemToolTips(prescriptionGetModel, pharmacyID),
      );
      getAutomationSummary({
        prescriptionIncomingId,
        pharmacyID,
      });
      getPatientMedicationData();
      getPrescriptionChecksData();
      getClinicalChecksPatientImageData();
      if (hasPatient) {
        getTitanPatientByPatientId({
          patientId,
          pharmacyID,
        });
      } else {
        setCurrentPatientData(null);
      }
    }
    if (hasPatient) {
      const today = new Date();
      let fromDate = new Date(today.setDate(today.getDate() - 60));
      const toDate = new Date();
      const formattedFrom = fromDate ? fromDate.toISOString() : null;
      const formattedTo = toDate.toISOString();
      getPatientHistory({
        currentPharmacyId: pharmacyID,
        patientId,
        fromDate: formattedFrom,
        toDate: formattedTo,
      });
    } else {
      setCurrentPatientHistory([]);
    }
    // The dispatcher catches its own errors, so this never rejects
    await itemChecksRequest;
    setAppLoading(false);
  };
  const getPrescriptionDataByIncomingId = async (
    prescriptionIncomingId,
    pharmacyID,
  ) => {
    const data = getPrescriptionByIncomingId({
      prescriptionIncomingId,
      pharmacyID,
    });
    return data;
  };
  const getPatientMedicationData = () => {
    const currentClinicalChecksState = store.getState().clinicalChecks;
    const { clinicalChecksPharmacy, patientId } =
      currentClinicalChecksState || {};

    const { pharmacyID } = clinicalChecksPharmacy || {
      pharmacyID: "00000000-0000-0000-0000-000000000000",
    };
    getPatientMedication({ patientId, pharmacyID });
  };
  const getPrescriptionItemCheckData = (prescriptionIncomingId) => {
    const currentClinicalChecksState = store.getState().clinicalChecks;
    const { clinicalChecksPharmacy, prescriptions } =
      currentClinicalChecksState || {};
    const { pharmacyID } = clinicalChecksPharmacy || {
      pharmacyID: "00000000-0000-0000-0000-000000000000",
    };
    const prescriptionItemChecksBody = new setPrescriptionItemChecks(
      prescriptions,
      0,
      "",
      "",
      false,
      "",
      prescriptionIncomingId,
    ).obj;
    return getPrescriptionItemCheck({
      prescriptionItemChecksBody,
      pharmacyID,
    });
  };
  const loadCCOrderItemToolTips = (prescriptionGetModel, pharmacyID) => {
    const requests = (prescriptionGetModel?.prescriptionItems || []).map(
      (item) => {
        const CCOrderTooltipBody = new setCCToolTipData({
          patientId: prescriptionGetModel?.patientId,
          prescriptionId: prescriptionGetModel?.prescriptionId,
          prescriptionIncomingId: prescriptionGetModel?.prescriptionIncomingId,
          prescribedItemId: item?.prescribedItemId,
          prescriptionItemId: item?.prescriptionItemId,
          epsLineItem: item?.epsLineItem,
          quantity: item?.quantity,
          hasFlavours: false,
          dosageText: item?.dosageText,
        });
        return setCCOrderItemToolTip({
          CCOrderTooltipBody,
          pharmacyID,
        });
      },
    );
    return Promise.allSettled(requests);
  };
  const getPrescriptionChecksData = () => {
    const currentClinicalChecksState = store.getState().clinicalChecks;
    const { clinicalChecksPharmacy, prescriptions } =
      currentClinicalChecksState || {};
    const { pharmacyID } = clinicalChecksPharmacy || {
      pharmacyID: "00000000-0000-0000-0000-000000000000",
    };
    const prescriptionCheckBody = new setPrescriptionChecks(prescriptions, "");
    getPrescriptionChecks({
      prescriptionCheckBody,
      pharmacyID,
    });
  };

  const getClinicalChecksPatientImageData = async () => {
    const currentClinicalChecksState = store.getState().clinicalChecks;
    const { prescriptions, clinicalChecksPharmacy } =
      currentClinicalChecksState || {};
    const { pharmacyID } = clinicalChecksPharmacy || {
      pharmacyID: "00000000-0000-0000-0000-000000000000",
    };
    const prescriptionImages = prescriptions?.prescriptionImages;
    if (prescriptionImages) {
      const results = await Promise.all(
        prescriptionImages.map((imageValue) =>
          getPatientImage({
            imageValue,
            pharmacyID,
          }),
        ),
      );
      const resultArray = results.map(
        (result) => `data:image/png;base64, ${result}`,
      );
      if (resultArray?.length > 0) {
        setPatientImage(resultArray);
      } else {
        setPatientImage([]);
      }
    }
  };

  const rolesAndPermissionsLoader = async ({ params }) => {
    setTeamLoading(true);
    let teamRoles = null;
    let teamPermissions = null;
    let appData = null;

    const finallyHandler = () => {
      setTeamLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setTeamLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          teamRoles = await getTeamsRoles(companyID);
          teamPermissions = await getPermissions();
          return { teamRoles, teamPermissions };
        } catch (error) {
          logErrorWithPayload(error);
          setTeamLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const rolesByIdLoader = async ({ params }) => {
    const { roleId } = params || {};
    setTeamLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setTeamLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setTeamLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const teamRoles = await getTeamsRoleById(roleId);
          const teamPermissions = await getPermissions();
          return { data, teamRoles, teamPermissions };
        } catch (error) {
          logErrorWithPayload(error);
          setTeamLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const rolesAddNewLoader = async ({ params }) => {
    setTeamLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setTeamLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setTeamLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const teamPermissions = await getPermissions();
          return { data, teamPermissions };
        } catch (error) {
          logErrorWithPayload(error);
          setTeamLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const NmsLoader = async ({ params }) => {
    setCurrentIsNmsLoading(true);
    setCurrentIsNmsTimelineLoading(true);
    setCurrentIsNmsPatientLoading(true);
    setCurrentIsNmsPrescriptionLoading(true);
    setCurrentIsServiceNotesLoading(true);
    setCurrentIsPatientNmsTelephoneLoading(true);
    setCurrentFollowUpcomments("");
    setCurrentTimelineElements([]);
    setAppLoading(true);
    let appData = null;
    try {
      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
        }
        return null;
      };

      const appDataHandler = (data) => {
        let currentAppState = store.getState().app;
        const { isOrbitUser, isOrbitSwitch } = currentAppState || {};

        if (isOrbitUser || isOrbitSwitch) {
          return getPharmacyIdForOrbitUser();
        } else {
          return null;
        }
      };

      const checkOrbitUserHandler = (data) => {
        const currentOrbitState = store.getState().orbit;
        const { isTestMode } = currentOrbitState || false;
        if (params?.serviceId === "0") {
          let currentAppState = store.getState().app;
          const { currentTeam, isOrbitUser, isOrbitSwitch, isAgencyUser } =
            currentAppState || {};
          if (data != null) {
            setCurrentPharmacy(data);
            currentAppState = store.getState().app;
            const currentSessionId = localStorage.getItem("currentSessionId");
            return getClinicalServiceFromOrbit({
              serviceCode: 1,
              sessionId: currentSessionId,
              isTestMode: isTestMode,
              isAgencyUser: isAgencyUser,
            });
          } else {
            const randomIndex = Math.floor(Math.random() * currentTeam?.length);
            const randomPharmacy = currentTeam?.pharmacies[randomIndex];
            setCurrentPharmacy(randomPharmacy);
            currentAppState = store.getState().app;
            const currentSessionId = localStorage.getItem("currentSessionId");
            return getClinicalServiceFromOrbit({
              serviceCode: 1,
              sessionId: currentSessionId,
              isTestMode: isTestMode,
              isAgencyUser: isAgencyUser,
            });
          }
        } else {
          return getClinicalServiceByClinicalServiceId(params.serviceId);
        }
      };

      const ClinicalServiceHandler = (service) => {
        if (service?.clinicalServiceBuilderResponseDTO) {
          getClinicalServiceResult(
            service,
            params?.serviceId === "0"
              ? service?.clinicalServiceBuilderResponseDTO?._id
              : params?.serviceId,
          );
        } else {
          return null;
        }
      };
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setCurrentIsNmsLoading(false);
        setCurrentIsNmsTimelineLoading(false);
        setCurrentIsNmsPatientLoading(false);
        setCurrentIsNmsPrescriptionLoading(false);
        setCurrentIsPatientNmsTelephoneLoading(false);
        return error;
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .then(checkOrbitUserHandler)
        .then(ClinicalServiceHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }

    return defer({ appData });
  };

  const privateServiceLoader = async ({ params }) => {
    setCurrentIsNmsLoading(true);
    setCurrentIsNmsTimelineLoading(true);
    setCurrentIsNmsPatientLoading(true);
    setCurrentIsNmsPrescriptionLoading(true);
    setCurrentIsServiceNotesLoading(true);
    setCurrentIsPatientNmsTelephoneLoading(true);
    setAppLoading(true);
    setSelectedVaccineDose([]);
    setShowVaccineBasket(false);
    let appData = null;
    try {
      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
        }
        return null;
      };

      const appDataHandler = (data) => {
        let currentAppState = store.getState().app;
        const { isOrbitUser, isOrbitSwitch } = currentAppState || {};

        if (isOrbitUser || isOrbitSwitch) {
          return getPharmacyIdForOrbitUser();
        } else {
          return null;
        }
      };

      const checkOrbitUserHandler = async (data) => {
        const currentOrbitState = store.getState().orbit;
        const { isTestMode } = currentOrbitState || false;
        if (params?.serviceId === "0") {
          let currentAppState = store.getState().app;
          const { currentTeam, isOrbitUser, isOrbitSwitch, isAgencyUser } =
            currentAppState || {};
          if (data != null) {
            setCurrentPharmacy(data);
            currentAppState = store.getState().app;
            const currentSessionId = localStorage.getItem("currentSessionId");
            return getClinicalServiceFromOrbit({
              serviceCode: 1,
              sessionId: currentSessionId,
              isTestMode: isTestMode,
              isAgencyUser: isAgencyUser,
            });
          } else {
            const randomIndex = Math.floor(Math.random() * currentTeam?.length);
            const randomPharmacy = currentTeam?.pharmacies[randomIndex];
            setCurrentPharmacy(randomPharmacy);
            currentAppState = store.getState().app;
            const currentSessionId = localStorage.getItem("currentSessionId");
            return getClinicalServiceFromOrbit({
              serviceCode: 1,
              sessionId: currentSessionId,
              isTestMode: isTestMode,
              isAgencyUser: isAgencyUser,
            });
          }
        } else {
          try {
            const clinicalServiceData = await getClinicalServiceByClinicalServiceId(
              params.serviceId,
            );
            getTimelineDataForClinicalServiceId(params.serviceId);
            if (clinicalServiceData) {
              const stagesData =
                clinicalServiceData?.clinicalServiceBuilderResponseDTO.stages[0]
                  .template.templateSections[0].userControls;
              setCurrentResponseDTOStagesData(stagesData);
            }

            return clinicalServiceData;
          } catch (error) {
            console.error("Error fetching clinical service:", error);
          }
        }
      };

      const ClinicalServiceHandler = (service) => {
        if (service?.clinicalServiceBuilderResponseDTO) {
          getPrivateServiceResult(
            service,
            params?.serviceId === "0"
              ? service?.clinicalServiceBuilderResponseDTO?._id
              : params?.serviceId,
          );
        } else {
          return null;
        }
      };
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setCurrentIsNmsLoading(false);
        setCurrentIsNmsTimelineLoading(false);
        setCurrentIsNmsPatientLoading(false);
        setCurrentIsNmsPrescriptionLoading(false);
        setCurrentIsPatientNmsTelephoneLoading(false);
        return error;
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .then(checkOrbitUserHandler)
        .then(ClinicalServiceHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
    }

    return defer({ appData });
  };

  const getMultiplePrescriptionImages = async (incomingIds, pharmacyID) => {
    const resultArray = [];
    var data = await getPrescriptionImagesByIncomingIds({
      incomingIds,
      pharmacyID,
    });
    if (data) {
      for (const imageValue of data) {
        resultArray.push(`data:image/png;base64, ${imageValue}`);
      }
      if (resultArray?.length > 0) {
        setCurrentArrayImg(resultArray);
      } else {
        setCurrentArrayImg([]);
      }
    }
    setCurrentIsNmsPrescriptionLoading(false);
  };

  const getClinicalServiceResult = (service, serviceId) => {
    let currentAppState = store.getState().app;
    const { isOrbitUser } = currentAppState || {};
    const { clinicalServiceBuilderResponseDTO, pharmacy, incomingIds } =
      service || {};

    const { pharmacyID } = pharmacy || {
      pharmacyID: clinicalServiceBuilderResponseDTO?.pharmacyID,
    };
    const {
      patientId,
      prescriptionIncomingId,
      telephoneNumber,
    } = clinicalServiceBuilderResponseDTO || {
      patientId: "00000000-0000-0000-0000-000000000000",
      prescriptionIncomingId: "00000000-0000-0000-0000-000000000000",
      telephoneNumber: null,
    };
    const currentSessionId = localStorage.getItem("currentSessionId");
    // if (isOrbitUser) {
    //   getTotalSkips({
    //     clinicalServiceId: serviceId,
    //     sessionId: currentSessionId,
    //   });
    // }
    getFollowupDetailByClinicalServiceId(serviceId);
    getServiceNotesByClinicalServiceId(serviceId);
    getTimelineDataForClinicalServiceId(serviceId);

    if (telephoneNumber !== null && telephoneNumber !== "") {
      getPatientByTelephoneAndStageIndex(telephoneNumber, serviceId);
    } else {
      setCurrentPatientNMSData([]);
    }

    setCurrentArrayImg([]);
    if (incomingIds?.length > 0) {
      const resultArray = [];
      getMultiplePrescriptionImages(incomingIds, pharmacyID);
    }
    if (
      patientId !== null &&
      patientId !== "00000000-0000-0000-0000-000000000000"
    ) {
      const clinicalServiceId = serviceId;
      getTitanPatient({ pharmacyID, patientId, clinicalServiceId }).then(
        (data) => {
          prescriptionPatientImage(data);
        },
      );
    } else {
      setCurrentIsNmsPatientLoading(false);
    }
    setCurrentIsServiceNotesLoading(false);
    setCurrentIsNmsTimelineLoading(false);
  };
  const getPrivateServiceResult = (service, serviceId) => {
    let currentAppState = store.getState().app;
    const { isOrbitUser } = currentAppState || {};
    const { clinicalServiceBuilderResponseDTO, pharmacy } = service || {};
    const { pharmacyID } = pharmacy || {
      pharmacyID: clinicalServiceBuilderResponseDTO?.pharmacyID,
    };
    const {
      patientId,
      prescriptionIncomingId,
      telephoneNumber,
    } = clinicalServiceBuilderResponseDTO || {
      patientId: "00000000-0000-0000-0000-000000000000",
      prescriptionIncomingId: "00000000-0000-0000-0000-000000000000",
      telephoneNumber: null,
    };
    const currentSessionId = localStorage.getItem("currentSessionId");
    getTravelInformation(serviceId);
    getPharmacyProducts(clinicalServiceBuilderResponseDTO?.pharmacyID);
    getVaccineInfo(serviceId);
    if (isOrbitUser) {
      getTotalSkips({
        clinicalServiceId: serviceId,
        sessionId: currentSessionId,
      });
    }
    if (telephoneNumber !== null && telephoneNumber !== "") {
      //getPatientByTelephoneAndStageIndex(telephoneNumber, serviceId);
    } else {
      setCurrentPatientNMSData([]);
    }
  };
  const getFollowupDetailByClinicalServiceId = (clinicalServiceId) => {
    const currentNmsState = store.getState().nmsService;
    const { value } = currentNmsState || {};
    const stageType = stageTypes[value];
    getFollowUpByServiceIdAndServiceType(clinicalServiceId, "1", stageType);
  };

  const getPatientByTelephoneAndStageIndex = (telephone, serviceId) => {
    const currentNmsState = store.getState().nmsService;
    let currentAppState = store.getState().app;
    const { isOrbitUser } = currentAppState || {};
    const { value } = currentNmsState || {};
    getPatientByTelephoneAndStageIndexResult(
      telephone,
      value,
      serviceId,
      isOrbitUser,
    );
    setCurrentIsPatientNmsTelephoneLoading(false);
  };

  const getServiceNotesByClinicalServiceId = (clinicalServiceId) => {
    const currentNmsState = store.getState().nmsService;
    const { value } = currentNmsState || {};
    const stageNo = value;
    const stageType = stageTypes[stageNo];

    getServiceNotes({ clinicalServiceId, stageType });
  };

  const getTimelineDataForClinicalServiceId = (serviceId) => {
    let currentAppState = store.getState().app;
    const { isOrbitUser, isOrbitSwitch } = currentAppState;
    const currentNmsState = store.getState().nmsService;
    const { clinicalServiceId } = currentNmsState || {};
    getTimeline(isOrbitUser || isOrbitSwitch ? clinicalServiceId : serviceId);
  };

  const prescriptionImageData = async (data, pharmacyID) => {
    if (data) {
      const { prescriptionGetModel } = data || {};
      const { prescriptionImages } = prescriptionGetModel ?? [];
      const resultArray = [];
      if (prescriptionImages) {
        for (const imageValue of prescriptionImages) {
          const result = await getPatientImage({
            imageValue,
            pharmacyID,
          });
          resultArray.push(`data:image/png;base64, ${result}`);
        }
        if (resultArray?.length > 0) {
          setCurrentArrayImg(resultArray);
        } else {
          setCurrentArrayImg([]);
        }
      }
    }
    setCurrentIsNmsPrescriptionLoading(false);
  };

  const prescriptionPatientImage = async (patientData) => {
    if (patientData) {
      const currentNmsState = store.getState().nmsService;
      const { prescriptionImages, pharmacyID } = currentNmsState || {};
      const { patientGetModel } = patientData || {};
      const patientName = `${patientGetModel.title} ${patientGetModel.forename} ${patientGetModel.middleName} ${patientGetModel.surname}`;
      setCurrentPatientName(patientName);
    }
    setCurrentIsNmsPatientLoading(false);
  };

  const generalDetailsLoader = async () => {
    setGeneralLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setGeneralLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setGeneralLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const currentAppState = store.getState().app;
          const { currentCompanyId } = currentAppState || {};
          const selectedCompanyId = currentCompanyId;
          const generalDetails = await getAllGenerals(
            selectedCompanyId !== "" ? selectedCompanyId : data?.companyID,
          );
          return { data, generalDetails };
        } catch (error) {
          logErrorWithPayload(error);
          setGeneralLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const billingDetailsLoader = async () => {
    setBillingLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setBillingLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setBillingLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.user) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const billingDetails = await getBillingContact();
          return { data, billingDetails };
        } catch (error) {
          logErrorWithPayload(error);
          setBillingLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const membersLoader = async () => {
    setMemberLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setMemberLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setMemberLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const currentAppState = store.getState().app;
          const { currentCompanyId } = currentAppState || {};
          const selectedCompanyId = currentCompanyId;
          const membersData = await getmembers(
            selectedCompanyId !== "" ? selectedCompanyId : companyID,
          );
          const rolesData = await getTeamsRoles(
            selectedCompanyId !== "" ? selectedCompanyId : companyID,
          );
          const servicesData = await getServices();
          return { data, membersData, rolesData, servicesData };
        } catch (error) {
          logErrorWithPayload(error);
          setMemberLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const memberAddNewLoader = async ({ params }) => {
    setMemberLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setMemberLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setMemberLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const companyID = data.companyID;
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const teamPermissions = await getPermissions();
          const serviceData = await getOrbitAgencyServicesByCompanyId(
            companyID,
          );
          return { data, teamPermissions, serviceData };
        } catch (error) {
          logErrorWithPayload(error);
          setMemberLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const memberByIdLoader = async ({ params }) => {
    const { memberId } = params || {};
    setMemberLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setMemberLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setMemberLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const companyID = data.companyID;
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const teamMembers = await getMemberById(memberId);
          const teamPermissions = await getPermissions();
          const serviceData = await getOrbitAgencyServicesByCompanyId(
            companyID,
          );
          const companyPharmacies = getPharmaciesByCompanyId(companyID);
          return {
            data,
            teamMembers,
            teamPermissions,
            serviceData,
            companyPharmacies,
          };
        } catch (error) {
          logErrorWithPayload(error);
          setMemberLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const consultationLoader = async ({ params }) => {
    let allTemplates = null;
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          allTemplates = await getAllTemplates(companyID);
          return { allTemplates };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const addConsultationLoader = async ({ params }) => {
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const aiConsultationLoader = async ({ params }) => {
    let aiTemplateByCompanyId = null;
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        try {
          aiTemplateByCompanyId = await getAiTemplateByCompanyId(companyID);
          return { aiTemplateByCompanyId };
        } catch (error) {
          logErrorWithPayload(error);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const patientConsultationsLoader = async ({ params }) => {
    const {
      selectedPatientDetails,
      comingFromPatientListView,
    } = store.getState().patient;
    const { patientId, pharmacyId, consultationId } = params || {};
    setisConsultationDataLoading(true);
    setSelectedPatientId(patientId);
    setSelectedPharmacyId(pharmacyId);
    setPatientSummary(null);
    setpatientCurrentSummaryArray(null);
    setpatientSummaryArray([]);
    setTogglePatientPanelTwo(false);
    setSecondPatientPanelTitle(null);
    setTogglePatientPanelOne(false);
    setFirstPatientPanelTitle(null);
    setIsDemDXTemplate(null);
    setChatQuestions("");
    setChatBotReferralLetter("");
    setPatientChatAnswersLoader(false);
    setIsChatReferralLetter(false);
    setAiqa([]);
    setFullTranscript([]);
    setPatientTabSwitcher(0);
    setIsSummaryGenerated(false);
    setReferralLetter("");
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setIncrementPaymentCompleted(false);
    setLetterDetails(null);
    setBookingDetails(null);
    setIncrementImageDocCompleted(false);
    setIncrementTreatmentPlanCompleted(false);
    // setSelectedPatientConsultation(null);
    // setSelectedTemplate([]);
    setHydratedTemplateSections(null);
    let aiTemplateByCompanyId = null;
    let patientVitalsbyPatientId = null;
    let patientAllergiesbyPatientId = null;
    let patientConditionRelatedbyPatientId = null;
    let patientMedicationsbyPatientId = null;
    let patientConsultationsbyPatientId = null;

    const age = (
      new Date().getFullYear() -
      new Date(selectedPatientDetails?.dob).getFullYear()
    ).toString();
    const gender = genderTypes[selectedPatientDetails?.sex] || "-";

    const demDXPayload = { gender, age };

    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };
    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };

    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setSelectedPatientId(patientId);
        setSelectedPharmacyId(pharmacyId);
        setPatientSummary(null);
        setpatientCurrentSummaryArray(null);
        setpatientSummaryArray([]);
        setTogglePatientPanelTwo(false);
        setSecondPatientPanelTitle(null);
        setTogglePatientPanelOne(false);
        setFirstPatientPanelTitle(null);
        setIsDemDXTemplate(null);
        setChatQuestions("");
        setPatientAIChatMessages([]);
        setChatBotReferralLetter("");
        setPatientChatAnswersLoader(false);
        setIsChatReferralLetter(false);
        setAiqa([]);
        setFullTranscript([]);
        setPatientTabSwitcher(0);

        setIsSummaryGenerated(false);
        setReferralLetter("");
        setHydratedTemplateSections(null);
        setVaccineDetails(null);
        setIncrementVaccineCompleted(false);
      }
      return null;
    };

    const appDataHandler = async (data) => {
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        try {
          if (consultationId != null && !comingFromPatientListView) {
            await getPatientConsultationByConsultationId(consultationId);
          }
          const currentAppState = store.getState().app;
          const { currentCompanyId } = currentAppState || {};
          const selectedCompanyId = currentCompanyId;

          getResources(
            selectedCompanyId !== "" ? selectedCompanyId : companyID,
            pharmacyId,
          );
          await getAiTemplateByCompanyId(
            selectedCompanyId !== "" ? selectedCompanyId : companyID,
          );
          await getPatientVitals(patientId);
          await getPatientAllergies(patientId);
          await getPatientConditionRelated(patientId);
          await getPatientMedications(patientId);
          await patientId;
          await getAllCompany(
            selectedCompanyId !== "" ? selectedCompanyId : companyID,
          );
          const demDxKey = localStorage.getItem("demDexToken");
          if (demDxKey !== "" && demDxKey !== null) {
            await generateDemDXAssessments(demDXPayload);
          }
          await GetPatientVitalsSummaryByPatientId(patientId);
          await getPatientActiveTreatmentPlan(patientId);
          setisConsultationDataLoading(false);
        } catch (error) {
          logErrorWithPayload(error);
          setisConsultationDataLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const patientDashboardLoader = async ({ params }) => {
    const { patientId, pharmacyId } = params || {};
    setisConsultationDataLoading(true);
    setIsPatientDetailsLoading(true);
    setIsDemDxActive(false);
    setSelectedPatientId(patientId);
    setSelectedPharmacyId(pharmacyId);
    setisPatientSearched(true);
    setPatientInfoTab(0);
    setIsPatientDashboard(true);
    setIsTemplateSelected(false);
    setSelectedTemplate([]);
    setPatientSummary(null);
    setDemDxSummary(null);
    setConsultationId("");
    setPatientTabSwitcher(0);
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setIsConsultationEnabled(false);
    setSelectedPatientConsultation(null);
    setHydratedTemplateSections(null);
    setTranscript("");
    setIsLocallyCompleted(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setIsFinalSummary(true);
    setConsultationAuditTimeline([]);
    setVaccineDetails(null);
    setPaymentAudit(null);
    setPreConsultationTranscription(null);
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };
    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setIsDemDxActive(false);
        setSelectedPatientId(patientId);
        setSelectedPharmacyId(pharmacyId);
        setisPatientSearched(true);
        setPatientInfoTab(0);
        setIsPatientDashboard(true);
        setIsTemplateSelected(false);
        setSelectedTemplate([]);
        setPatientSummary(null);
        setDemDxSummary(null);
        setConsultationId("");
        setPatientTabSwitcher(0);

        setSelectedTemplateContent([]);
        setPatientAIChatMessages([]);
        setIsConsultationEnabled(false);
        setSelectedPatientConsultation(null);
        setHydratedTemplateSections(null);
        setTranscript("");
      }
      return null;
    };

    const appDataHandler = async (data) => {
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      try {
        const patient = await getPatientByPatientId(patientId);
        const appointments = await getPatientAppointmentsByPatientId(patientId);
        const patientPayment = await getPaymentAnalyticsByPatientId(patientId);
        const patientVitalsbyPatientId = await getPatientVitals(patientId);
        const patientConsultation = await getPatientConsultations(patientId);
        const patientActiveConsultation = await getPatientActiveConsultation(
          patientId,
        );
        return {
          patient,
          appointments,
          patientPayment,
        };
      } catch (error) {
        logErrorWithPayload(error);
        return error;
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const patientListViewLoader = async ({ params }) => {
    const { pharmacyId } = params || {};
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    let appData = null;
    setIsPatientListLoaderData(true);
    const finallyHandler = () => {
      setAppLoading(false);
    };
    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };

    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setisPatientSearched(false);
        setIsPatientDashboard(false);
      }
      return null;
    };

    const appDataHandler = async (data) => {
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      const currentAppState = store.getState().app;
      const { companyId } = currentAppState || {};
      if (pharmacyId) {
        try {
          const payload = {
            keyword: "",
            practitioners: "",
            treatmentPlan: "",
            isTitanSearch: false,
            consultationStatus: 0,
            pharmacyID: pharmacyId,
            companyId: companyId,
          };
          const patientListData = await getPatientsListV2(payload);
          setIsPatientListLoaderData(false);

          return {
            patientListData,
          };
        } catch (error) {
          logErrorWithPayload(error);
          return error;
        }
      }

      return data;
    };

    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const typeLoader = async ({ params }) => {
    let allServicesTypes = null;
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          allServicesTypes = await getServicesByCompany(companyID);
          return { allServicesTypes };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const typeAddNewLoader = async () => {
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          let allTemplates = [];
          let companyPharmacies = [];
          let newServiceType = null;
          if (data?.companyID) {
            newServiceType = {
              pharmacyIds: [],
              serviceModel: {
                isDefault: false,
                companyID: data?.companyID,
                serviceType: 2,
                serviceName: "",
                serviceDescription: "",
                serviceCharges: 0,
                serviceDuration: 0,
                serviceColor: "",
                notificationTemplates: [
                  {
                    myProperty: 0,
                    notificationTemplateType: 1,
                  },
                ],
                serviceCode: 0,
                isOnlineBooking: false,
              },
              clinicalServiceBuilder: {
                serviceName: "",
                stages: [],
                numberOfStages: 0,
                serviceType: 2,
                companyID: data?.companyID,
                isDefault: false,
                serviceID: "",
                serviceCode: 0,
              },
            };

            companyPharmacies = getPharmaciesByCompanyId(data?.companyID);
            allTemplates = getAllTemplates(data?.companyID);

            setCurrentType(newServiceType);
          }
          return { newServiceType, allTemplates, companyPharmacies };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const typeByServiceIdLoader = async ({ params }) => {
    const { serviceId } = params || {};
    let typeByServiceId = null;
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };

    const appDataHandler = async (data) => {
      if (data) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          let allTemplates = [];
          let companyPharmacies = [];
          if (data?.companyID) {
            companyPharmacies = getPharmaciesByCompanyId(data?.companyID);
            allTemplates = getAllTemplates(data?.companyID);
          }
          typeByServiceId = await getServiceTypeById(serviceId);
          return { typeByServiceId, allTemplates, companyPharmacies };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const locationLoader = async () => {
    // setLocationLoading(true);
    let appData = null;

    const finallyHandler = () => {
      // setLocationLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      // setLocationLoading(false);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const companyPharmacies = getPharmaciesByCompanyId(data?.companyID);
          return { data, companyPharmacies };
        } catch (error) {
          logErrorWithPayload(error);
          // setLocationLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const locationAddNewLoader = async ({ params }) => {
    const { pharmacyId } = params || {
      pharmacyId: "00000000-0000-0000-0000-000000000000",
    };
    // setLocationLoading(true);
    let appData = null;

    const finallyHandler = () => {
      // setLocationLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      // setLocationLoading(false);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const servicesByPharmacyId = await getServicesByPharmacyId(
            pharmacyId,
          );
          const teamPermissions = await getPermissions();
          return { data, teamPermissions, servicesByPharmacyId };
        } catch (error) {
          logErrorWithPayload(error);
          // setLocationLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };
  const locationUpdateNewLoader = async ({ params }) => {
    const { pharmacyId } = params || {
      pharmacyId: "00000000-0000-0000-0000-000000000000",
    };
    // setLocationLoading(true);
    let appData = null;

    const finallyHandler = () => {
      // setLocationLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      // setLocationLoading(false);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      if (data?.companyID) {
        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          const servicesByPharmacyId = await getServicesByPharmacyId(
            pharmacyId,
          );
          const teamPermissions = await getPermissions();
          return { data, teamPermissions, servicesByPharmacyId };
        } catch (error) {
          logErrorWithPayload(error);
          // setLocationLoading(false);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const OrbitSettingsLoader = async () => {
    setCurrentOrbitLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setCurrentOrbitLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setCurrentOrbitLoading(false);
      setAppLoading(false);
      return error;
    };
    const appDataHandler = (data) => {
      try {
        return getOrbitProfile();
      } catch (error) {
        logErrorWithPayload(error);
        setCurrentOrbitLoading(false);
        setAppLoading(false);
        return error;
      }
    };

    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };
  const orbitDashboardLoader = async () => {
    setCurrentOrbitLoading(true);
    setIsMonthlyReportLoading(true);
    setIsOrbitEarningLoading(true);
    setIsUserSessionLoading(true);
    setIsPotentialEarningLoading(true);
    setIsFollowupLoading(true);
    setIsOtherDetailsLoading(true);
    setIsActiveServicesLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setCurrentOrbitLoading(false);
      setIsMonthlyReportLoading(false);
      setIsOrbitEarningLoading(false);
      setIsUserSessionLoading(false);
      setIsPotentialEarningLoading(false);
      setIsFollowupLoading(false);
      setIsOtherDetailsLoading(false);
      setIsActiveServicesLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setCurrentOrbitLoading(false);
      setIsMonthlyReportLoading(false);
      setIsOrbitEarningLoading(false);
      setIsUserSessionLoading(false);
      setIsPotentialEarningLoading(false);
      setIsFollowupLoading(false);
      setIsOtherDetailsLoading(false);
      setIsActiveServicesLoading(false);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setCurrentOrbitLoading(false);
        setIsMonthlyReportLoading(false);
        setIsOrbitEarningLoading(false);
        setIsUserSessionLoading(false);
        setIsPotentialEarningLoading(false);
        setIsFollowupLoading(false);
        setIsOtherDetailsLoading(false);
        setIsActiveServicesLoading(false);
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = (data) => {
      try {
        const { user } = data;
        const { companyID } = user;
        const storedOption = localStorage.getItem("selectedOption");
        const currentAppState = store.getState().app;
        const { companyId } = currentAppState || {};

        if (user?.accountType === 2 || storedOption === "orbit") {
          const currentDate = moment();
          const currentOrbitState = store.getState().orbit;
          const { isTestMode } = currentOrbitState || false;
          const firstDayOfMonth = moment(currentDate).startOf("month");
          const lastDayOfMonth = moment(currentDate).endOf("month");
          const startDate = firstDayOfMonth.format("YYYY-MM-DDTHH:mm:ss");
          const endDate = lastDayOfMonth.format("YYYY-MM-DDTHH:mm:ss");
          const currentSessionId = localStorage.getItem("currentSessionId");
          getUser("");
          if (
            checkUserPermissions(accessOwner) ||
            checkUserPermissions(accessAgencyUser)
          ) {
            setisAgencyUser(true);
          } else {
            setisAgencyUser(false);
          }
          if (checkUserPermissions(accessOwner)) {
            const strDate =
              startDate instanceof Date ? startDate : new Date(startDate);
            const enDate =
              endDate instanceof Date ? endDate : new Date(endDate);

            // Format dates to ISO string with UTC midnight
            const formattedStartDate = new Date(
              Date.UTC(
                strDate.getFullYear(),
                strDate.getMonth(),
                strDate.getDate(),
                0,
                0,
                0,
                0,
              ),
            ).toISOString();

            const formattedEndDate = new Date(
              Date.UTC(
                enDate.getFullYear(),
                enDate.getMonth(),
                enDate.getDate(),
                0,
                0,
                0,
                0,
              ),
            ).toISOString();
            getOrbitAgencyMonthlyReport({
              formattedStartDate,
              formattedEndDate,
              companyID: user?.companyID,
            });
            getOrbitAgencyUsers(user?.companyID);
            getOrbitAgencyDetails(user?.companyID);
            getOrbitServicesWorkPlanner(user?.companyID);
            getOrbitPharmanautsWorkPlanner(user?.companyID);
            getOrbitWorkPlanner(user?.companyID);
            getOrbitAgencyOtherDetails(user?.companyID);
            getOrbitAgencyPharmacies({
              companyId: user?.companyID,
              workLoadType: "1",
            });
            getOthersAvailable();
            getOrbitAgencyOtherPharmacies({
              companyId: companyID,
              workLoadType: "2",
            });
          } else {
            getOrbitMonthlyReport({ startDate, endDate });
            getOrbitEarnings({ startDate, endDate });
            getOrbitFollowUpServices();
            getOrbitPotentialEarnings();
            getOrbitParkedServices(isTestMode);
            getOrbitActiveServices({ currentSessionId, isTestMode });
            getOrbitOtherDetails();
            getOrbitUserSessions();
            getPaymentDetails();
            getOrbitLiveNms(user?.companyID);
          }

          if (user.companyID !== null) {
            getOrbitTeamByCompanyId(user?.companyID);
          }

          return data;
        } else {
          const redirectTo = onOrbitLoaded();
          return redirectTo;
        }
      } catch (error) {
        logErrorWithPayload(error);
        setCurrentOrbitLoading(false);
        setIsMonthlyReportLoading(false);
        setIsOrbitEarningLoading(false);
        setIsUserSessionLoading(false);
        setIsPotentialEarningLoading(false);
        setIsFollowupLoading(false);
        setIsOtherDetailsLoading(false);
        setIsActiveServicesLoading(false);
        setAppLoading(false);
        return error;
      }
    };

    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const consentFormLoader = async ({ params }) => {
    const { serviceId } = params || {};
    setConsentLoading(true);
    let appData = null;

    const finallyHandler = () => {
      setConsentLoading(false);
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setConsentLoading(false);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = (data) => {
      try {
        const consentData = getAllConsentData(serviceId);
        return { data, consentData };
      } catch (error) {
        logErrorWithPayload(error);
        setConsentLoading(false);
        setAppLoading(false);
        return error;
      }
    };

    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };
  const differentOrganizationLoader = async () => {
    setAppLoading(true);
    let appData = null;

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = (data) => {
      try {
        const currentOnBoardingState = store.getState().onboardingVerification;
        const { userData } = currentOnBoardingState || {};
        const { companyID, newCompanyID } = userData || {};
        const orgData = getCompanyNames({
          oldCompanyId: companyID,
          newCompanyId: newCompanyID,
        });
        return { data, orgData };
      } catch (error) {
        logErrorWithPayload(error);
        setConsentLoading(false);
        setAppLoading(false);
        return error;
      }
    };

    appData = Promise.resolve(null)
      .then(appDataHandler)
      .catch(errorHandler);
    return defer({ appData });
  };

  const emailsAndSmsTemplatesLoader = async ({ params }) => {
    let allTemplates = null;
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };

    const appDataHandler = async (data) => {
      if (data?.companyID) {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        setAppLoading(false);
        const redirectTo = onSettingsLoaded();
        if (redirectTo !== null) {
          setAppLoading(true);
          return redirectTo;
        }

        try {
          allTemplates = await getEmailsAndSmsTemplates(companyID);
          return { allTemplates };
        } catch (error) {
          logErrorWithPayload(error);
          setAppLoading(false);
          return error;
        }
      }

      return data;
    };
    appData = getApplicationData()
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const scheduleEventsLoader = async ({ params, request }) => {
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setEventsLoading(true);
    const { pharmacyId } = params || {};
    // schedule-new (New Calendar) needs the resources list; the legacy scheduler needs allPharmacists
    const isScheduleNewRoute = request.url.includes("/schedule-new/");
    // Set by dashboard "appointment" clicks, which force a specific date/day
    // view themselves - fetching the saved default view would be wasted and
    // could momentarily flash/override the forced view. Read from
    // localStorage (not a URL param) so the address bar stays clean.
    const skipDefaultCalendarView =
      localStorage.getItem("calendarFromAppointment") === "1";
    setIsDemDxActive(false);

    setIsTemplateSelected(false);
    setSelectedTemplate([]);
    setPatientSummary(null);
    setDemDxSummary(null);
    setConsultationId("");
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setIsConsultationEnabled(false);
    setSelectedPatientConsultation(null);
    setHydratedTemplateSections(null);
    setTranscript("");
    setIsLocallyCompleted(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setConsultationAuditTimeline([]);
    setPreConsultationTemplate(null);
    setPreConsultationTranscription(null);
    setSelectedPatientDetails(null);
    setBookingSlotsMode("");
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setEventsLoading(false);
        setAppLoading(false);
        setIsDemDxActive(false);
        setIsTemplateSelected(false);
        setSelectedTemplate([]);
        setPatientSummary(null);
        setDemDxSummary(null);
        setConsultationId("");
        setSelectedTemplateContent([]);
        setPatientAIChatMessages([]);
        setIsConsultationEnabled(false);
        setSelectedPatientConsultation(null);
        setHydratedTemplateSections(null);
        setTranscript("");
        setIsLocallyCompleted(false);
        setIsSummaryGenerated(false);
        setConsultationPaused(false);
        setConsultationAuditTimeline([]);
        setPreConsultationTemplate(null);
      }
      return null;
    };
    const appDataHandler = (data) => {
      const { companyID } = data || {
        companyID: "00000000-0000-0000-0000-000000000000",
      };
      try {
        const currentAppState = store.getState().app;
        const { currentCompanyId } = currentAppState || {};
        const selectedCompanyId = currentCompanyId;
        const scheduleEvents = getScheduleEvents(pharmacyId);
        const googleEvents = getGoogleEvents(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
          pharmacyId,
        );

        const resources = !isScheduleNewRoute
          ? getResources(
              selectedCompanyId !== "" ? selectedCompanyId : companyID,
              pharmacyId,
            )
          : undefined;
        const allPharmacists =
          isScheduleNewRoute || !isScheduleNewRoute
            ? getAllPharmacists(
                selectedCompanyId !== "" ? selectedCompanyId : companyID,
                pharmacyId,
              )
            : undefined;
        const pharmacyServices = getPharmacyClinicalServices(pharmacyId);

        const companyServices = getDefaultCompanyServices(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        const allUserWeekAvailability = getAllUserWeekAvailability();
        const userDefaultCalendarView = skipDefaultCalendarView
          ? undefined
          : getUserDefaultCalendarView(
              selectedCompanyId !== "" ? selectedCompanyId : companyID,
            );
        // A saved pharmacy filter only sets the selection; its events live in a
        // separate store field that is empty until this call populates it.
        const savedPharmacyEvents =
          isScheduleNewRoute && userDefaultCalendarView
            ? userDefaultCalendarView.then((view) => {
                const filters =
                  view?.calendarFilters ??
                  view?.response?.calendarFilters ??
                  view?.result?.calendarFilters;
                const pharmacyIds = Array.isArray(filters?.pharmacyIds)
                  ? filters.pharmacyIds.filter(Boolean)
                  : [];
                return pharmacyIds.length > 0
                  ? getScheduleEventsByPharmacies(pharmacyIds, {
                      silent: true,
                    })
                  : null;
              })
            : undefined;
        return {
          savedPharmacyEvents,
          scheduleEvents,
          googleEvents,
          resources,
          allPharmacists,
          pharmacyServices,
          companyServices,
          allUserWeekAvailability,
          userDefaultCalendarView,
        };
      } catch (error) {
        logErrorWithPayload(error);
        setAppLoading(false);
        setEventsLoading(false);
        return error;
      }
    };

    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const patientDashboardV2Loader = async ({ params }) => {
    const { patientId, pharmacyId } = params || {};
    setIsDemDxActive(false);
    setSelectedPatientId(patientId);
    setSelectedPharmacyId(pharmacyId);
    setisPatientSearched(true);
    setPatientInfoTab(0);
    setIsPatientDashboard(true);
    setIsTemplateSelected(false);
    setSelectedTemplate([]);
    setPatientSummary(null);
    setDemDxSummary(null);
    setConsultationId("");
    setPatientTabSwitcher(0);
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setIsConsultationEnabled(false);
    setSelectedPatientConsultation(null);
    setHydratedTemplateSections(null);
    setTranscript("");
    setIsLocallyCompleted(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setConsultationAuditTimeline([]);
    setPreConsultationTemplate(null);
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setIncrementPaymentCompleted(false);
    setLetterDetails(null);
    setPaymentAudit(null);
    setPreConsult(null);
    setPreConsultationTranscription(null);
    setBookingDetails(null);
    setIsSummaryStreaming(false);
    setisManualSubmited(false);
    setIncrementImageDocCompleted(false);
    setIncrementTreatmentPlanCompleted(false);
    setPatientConsultations(null);
    setAddPatientAIChatMessage([]);
    setQuickActionsTabSwitch(0);
    setTranscriptionState("idle");
    setAccessRecord(null);
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };
    const errorHandler = (error) => {
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setIsDemDxActive(false);
        setSelectedPatientId(patientId);
        setSelectedPharmacyId(pharmacyId);
        setisPatientSearched(true);
        setPatientInfoTab(0);
        setIsPatientDashboard(true);
        setIsTemplateSelected(false);
        setSelectedTemplate([]);
        setPatientSummary(null);
        setDemDxSummary(null);
        setConsultationId("");
        setPatientTabSwitcher(0);

        setSelectedTemplateContent([]);
        setPatientAIChatMessages([]);
        setIsConsultationEnabled(false);
        setSelectedPatientConsultation(null);
        setHydratedTemplateSections(null);
        setTranscript("");
        setPreConsultationTemplate(null);
      }
      return null;
    };

    const appDataHandler = async (data) => {
      const { companyID } = data || {
        companyID: "00000000-0000-0000-0000-000000000000",
      };
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      try {
        const patient = getPatientByPatientId(patientId);
        const patientAllergies = getPatientAllergies(patientId);
        const patientConditionRelatedbyPatientId = getPatientConditionRelated(
          patientId,
        );
        const patientVitalsbyPatientId = getPatientVitals(patientId);
        const patientMedicationsbyPatientId = getPatientMedications(patientId);
        const appointments = getPatientAppointmentsByPatientId(patientId);
        // const patientPayment =  getPaymentAnalyticsByPatientId(patientId);
        const patientConsultation = getPatientConsultations(patientId);
        const patientDocuments = getPatientDocuments(patientId);
        const patientPrescriptions = getPatientPrescriptionsByPatientId(
          patientId,
        );
        const patientActiveConsultation = getPatientActiveConsultation(
          patientId,
        );
        const preConsultTemplate = getPreConsultTemplateByCompanyId(companyID);
        const patientQuestionnaires = getPatientQuestionnairesByPatientyId(
          patientId,
        );
        const patientVaccinations = getPatientVaccinationByPatientId(patientId);
        const patientTreatmentPlan = getPatientActiveTreatmentPlan(patientId);
        return {
          patient,
          appointments,
          // patientPayment,
          patientMedicationsbyPatientId,
          patientAllergies,
          patientConditionRelatedbyPatientId,
          patientVitalsbyPatientId,
          patientDocuments,
          patientConsultation,
          patientPrescriptions,
          patientActiveConsultation,
          preConsultTemplate,
          patientQuestionnaires,
          patientVaccinations,
          patientTreatmentPlan,
        };
      } catch (error) {
        logErrorWithPayload(error);
        return error;
      }

      return data;
    };
    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const pharmacyDashboardLoader = async ({ params }) => {
    setisConsultationDataLoading(true);
    setPharmacyDashboardLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setSelectedPatientConsultation(null);
    setPatientSummary(null);
    setpatientCurrentSummaryArray(null);
    setpatientSummaryArray([]);
    setTogglePatientPanelTwo(false);
    setSecondPatientPanelTitle(null);
    setTogglePatientPanelOne(false);
    setFirstPatientPanelTitle(null);
    setIsDemDXTemplate(null);
    setChatQuestions("");
    setChatBotReferralLetter("");
    setPatientChatAnswersLoader(false);
    setIsChatReferralLetter(false);
    setAiqa([]);
    setFullTranscript([]);
    setPatientTabSwitcher(0);
    setIsSummaryGenerated(false);
    setReferralLetter("");
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setLetterDetails(null);
    setBookingDetails(null);
    setIsDemDxActive(false);
    setIsTemplateSelected(false);
    setSelectedTemplate([]);
    setPatientSummary(null);
    setDemDxSummary(null);
    setConsultationId("");
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setIsConsultationEnabled(false);
    setSelectedPatientConsultation(null);
    setHydratedTemplateSections(null);
    setTranscript("");
    setIsLocallyCompleted(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setConsultationAuditTimeline([]);
    setPreConsultationTemplate(null);
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setIncrementPaymentCompleted(false);
    setLetterDetails(null);
    setPaymentAudit(null);
    setPreConsult(null);
    setPreConsultationTranscription(null);
    setBookingDetails(null);
    setIsSummaryStreaming(false);
    setisManualSubmited(false);
    setIncrementImageDocCompleted(false);
    setIncrementTreatmentPlanCompleted(false);
    setSelectedPatientId("");
    setSelectedPharmacyId(params.pharmacyId);
    setIsSummaryGenerated(false);
    setPatientConsultations(null);
    setAddPatientAIChatMessage([]);
    setTranscriptionState("idle");

    let redirectTo = null;
    const { currentCompanyId } = store.getState().app || {};
    let appData = null;
    try {
      const appDataHandler = async (data) => {
        const { companyID, user } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };
        const pharmacyID = params.pharmacyId;
        const selectedCompanyId = currentCompanyId;
        const currentUserEmail =
          user?.emailAddress || store.getState().app?.currentUser?.emailAddress;
        const payloadModel =
          typeof currentUserEmail === "string" && currentUserEmail.trim() !== ""
            ? [currentUserEmail]
            : [];

        const dashboardData = getPharmacyDashboard({
          pharmacyID: pharmacyID,
          companyID: selectedCompanyId !== "" ? selectedCompanyId : companyID,
        });
        const companyServices = getDefaultCompanyServices(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        const scheduleEvents = getScheduleEventsByUser(
          pharmacyID,
          payloadModel,
        );
        const activeCOnsultation = getActiveConsultationsByUser(
          pharmacyID,
          payloadModel,
        );
        const pharmacyNotifications = getPharmacyNotifications(pharmacyID);
        getDoseShortCodeList(pharmacyID);
        return {
          dashboardData,
          companyServices,
          scheduleEvents,
          activeCOnsultation,
          pharmacyNotifications,
        };
      };

      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
          setTabLoading(false);
        }
        return null;
      };

      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };
      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
      setTabLoading(false);
    }

    return defer({ appData });
  };

  const patientApprovalLoader = async ({ params }) => {
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setSelectedPatientConsultation(null);
    setPatientSummary(null);
    setpatientCurrentSummaryArray(null);
    setpatientSummaryArray([]);
    setTogglePatientPanelTwo(false);
    setSecondPatientPanelTitle(null);
    setTogglePatientPanelOne(false);
    setFirstPatientPanelTitle(null);
    setIsDemDXTemplate(null);
    setChatQuestions("");
    setChatBotReferralLetter("");
    setPatientChatAnswersLoader(false);
    setIsChatReferralLetter(false);
    setAiqa([]);
    setFullTranscript([]);
    setPatientTabSwitcher(0);
    setIsSummaryGenerated(false);
    setReferralLetter("");
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setLetterDetails(null);
    setBookingDetails(null);
    setIsDemDxActive(false);
    setIsTemplateSelected(false);
    setSelectedTemplate([]);
    setPatientSummary(null);
    setDemDxSummary(null);
    setConsultationId("");
    setSelectedTemplateContent([]);
    setPatientAIChatMessages([]);
    setIsConsultationEnabled(false);
    setSelectedPatientConsultation(null);
    setHydratedTemplateSections(null);
    setTranscript("");
    setIsLocallyCompleted(false);
    setIsSummaryGenerated(false);
    setConsultationPaused(false);
    setConsultationAuditTimeline([]);
    setPreConsultationTemplate(null);
    setVaccineDetails(null);
    setIncrementVaccineCompleted(false);
    setIncrementPrescriptionCompleted(false);
    setPrescriptionDetails(null);
    setIncrementReferralCompleted(false);
    setIncrementBookingCompleted(false);
    setIncrementVitalsCompleted(false);
    setVitalsDetails(null);
    setIncrementSignatureCompleted(false);
    setSignatureDetails(null);
    setIncrementPaymentCompleted(false);
    setLetterDetails(null);
    setPaymentAudit(null);
    setPreConsult(null);
    setPreConsultationTranscription(null);
    setBookingDetails(null);
    setIsSummaryStreaming(false);
    setisManualSubmited(false);
    setIncrementImageDocCompleted(false);
    setIncrementTreatmentPlanCompleted(false);
    setSelectedPatientId("");
    setSelectedPharmacyId(params.pharmacyId);
    setIsSummaryGenerated(false);
    setPatientConsultations(null);
    setAddPatientAIChatMessage([]);
    setQuickActionsTabSwitch(0);
    setTranscriptionState("idle");

    const { pharmacyId } = params || {};
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setEventsLoading(false);
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = async (data) => {
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      const { companyID } = data || {
        companyID: "00000000-0000-0000-0000-000000000000",
      };
      try {
        await getUserCertificate();
        const currentAppState = store.getState().app;
        const { currentCompanyId } = currentAppState || {};
        const selectedCompanyId = currentCompanyId;
        await getPatientPrescriptions(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        await getDefaultCompanyServices(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );

        return { data };
      } catch (error) {
        logErrorWithPayload(error);
        setAppLoading(false);
        setEventsLoading(false);
        return error;
      }
    };

    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const companyDocumentsLoader = async ({ params }) => {
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setIsCompanyDocumentLoading(true);
    setSelectedPatientConsultation(null);
    const currentonboardingVerificationState = store.getState()
      .onboardingVerification;
    const { userData } = currentonboardingVerificationState;
    const type = userData?.accountType;
    const { pharmacyId } = params || {};
    let appData = null;

    const finallyHandler = () => {
      setAppLoading(false);
    };

    const errorHandler = (error) => {
      console.log(error);
      if (error instanceof Response && error?.status === 302) {
        throw error;
      }
      logErrorWithPayload(error);
      setAppLoading(false);
      return error;
    };
    const authTokenHandler = (authToken) => {
      if (authToken) {
        return getApplicationData();
      } else {
        setIsCompanyDocumentLoading(false);
        setAppLoading(false);
      }
      return null;
    };
    const appDataHandler = (data) => {
      const redirectTo = null;
      teamAndPharmacyHandler(redirectTo, data, params);
      const { companyID } = data || {
        companyID: "00000000-0000-0000-0000-000000000000",
      };
      try {
        const currentAppState = store.getState().app;
        const { currentCompanyId } = currentAppState || {};
        const selectedCompanyId = currentCompanyId;
        const members = getmembers(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        const companyDocuments = getCompanyDocumentsByCompanyId(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        const roles = getDocumentRoles(
          selectedCompanyId !== "" ? selectedCompanyId : companyID,
        );
        return { members, companyDocuments, roles };
      } catch (error) {
        logErrorWithPayload(error);
        setAppLoading(false);
        setIsCompanyDocumentLoading(false);
        return error;
      }
    };

    appData = getAuthToken()
      .then(authTokenHandler)
      .then(appDataHandler)
      .catch(errorHandler)
      .finally(finallyHandler);

    return defer({ appData });
  };

  const AnalyticsLoader = async ({ params }) => {
    setSelectedPatientConsultation(null);
    let appData = null;
    const { pharmacyId } = params;
    const finallyHandler = () => {
      setAppLoading(false);
    };
    try {
      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setTabLoading(false);
        return error;
      };
      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
          setPharmacyServiceLoading(false);
          setAppLoading(false);
          setTabLoading(false);
        }
        return null;
      };
      const appDataHandler = async (data) => {
        const { companyID } = data || {
          companyID: "00000000-0000-0000-0000-000000000000",
        };

        try {
          const now = new Date();
          const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
          const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          endDate.setHours(23, 59, 59, 999);
          const currentAppState = store.getState().app;
          const { currentCompanyId } = currentAppState || {};
          const selectedCompanyId = currentCompanyId;
          const servicesData = await fetchServicesTab({
            companyID: selectedCompanyId !== "" ? selectedCompanyId : companyID,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
          });

          return {
            ...data,
            servicesData,
          };
        } catch (error) {
          logErrorWithPayload(error);
          return error;
        }

        return data;
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
      setTabLoading(false);
    }

    return defer({ appData });
  };

  const titanTabLoader = async ({ params }) => {
    setTabLoading(true);
    setisPatientSearched(false);
    setIsPatientDashboard(false);
    setTitanTabLoading(true);
    let appData = null;

    try {
      const authTokenHandler = (authToken) => {
        if (authToken) {
          return getApplicationData();
        } else {
          setTabLoading(false);
          setAppLoading(false);
          setTitanTabLoading(false);
        }
        return null;
      };

      const appDataHandler = async (data) => {
        const redirectTo = onPharmacyServiceLoaded();
        setCurrentTeam(null);
        setCurrentPharmacy(null);

        const isteamAndPharmacyHandled = teamAndPharmacyHandler(
          redirectTo,
          data,
          params,
        );

        if (isteamAndPharmacyHandled === true) {
          const { companyID } = data || {
            companyID: "00000000-0000-0000-0000-000000000000",
          };
          const currentAppState = store.getState().app;
          const { currentCompanyId } = currentAppState || {};
          const selectedCompanyId =
            currentCompanyId !== "" ? currentCompanyId : companyID;

          await Promise.all([
            getCompanyProductRulesByCompanyId(selectedCompanyId),
            getPharmaciesByCompanyId(selectedCompanyId),
          ]);
        }

        return redirectTo !== null ? redirectTo : data;
      };

      const finalHandler = (data) => {
        setAppLoading(false);
        setTabLoading(false);
        setTitanTabLoading(false);
        return data;
      };

      const errorHandler = (error) => {
        logErrorWithPayload(error);
        setAppLoading(false);
        setTabLoading(false);
        setTitanTabLoading(false);
        return error;
      };

      appData = getAuthToken()
        .then(authTokenHandler)
        .then(appDataHandler)
        .then(finalHandler)
        .catch(errorHandler);
    } catch (error) {
      logErrorWithPayload(error);
      appData = null;
      setAppLoading(false);
      setTabLoading(false);
      setTitanTabLoading(false);
    }

    return defer({ appData });
  };

  // #endregion

  // #region Routers and config related function
  const signout = async () => {
    markLoggingOut();
    localStorage.setItem("titan_logout_event", Date.now().toString());
    localStorage.setItem("loginRequired", true);
    localStorage.setItem("selectedOption", null);
    localStorage.removeItem("companySelectionRedirected");
    showInfo("Logging out please wait...", false);
    setAppLoading(true);
    updateUserCurrentStatus(1).then((result) => {
      removeAuth();
    });
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const loadRoutes = (root) => {
    const RouteLayout = () => (
      <>
        <GAListener />
        <Outlet />
      </>
    );
    let customRoutes = [
      {
        element: <RouteLayout />,
        children: [
          {
            path: "/",
            element: <Dashboard />,
            loader: dashboardLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/multi-branch-dashboard",
            element: <MultiBranchDashboard />,
            loader: multiBranchDashboardLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/clinicalchecks/:pharmacyId/:incomingId",
            element: <ClinicalChecks />,
            shouldRevalidate: () => false,
            loader: getClinicalChecksLoader,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/clinicalservices/:clinicalServiceId",
            element: <ClinicalServices />,
            loader: NmsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/nmsintervention/:serviceId/",
            element: <NmsIntervention />,
            loader: NmsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/privateservice/:serviceId/",
            element: <PrivateService />,
            loader: privateServiceLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/consultation/:serviceId/",
            element: <Consultation />,
            loader: privateServiceLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/patientform",
            element: <PatientForm />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/pharmacyoverview/:pharmacyId",
            element: <PharmacyOverview />,
            loader: pharmacyOverviewTabLoader,
            shouldRevalidate: () => true,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/pharmacypatient/:pharmacyId",
            element: <PharmacyPatient />,
            loader: pharmacyPatientTabLoader,
            shouldRevalidate: () => true,
            errorElement: () => {
              return <NotFound />;
            },
          },
          // {
          //   path: "/pharmacyservices/:pharmacyId",
          //   element: <PharmacyServices />,
          //   loader: pharmacyServicesTabLoader,
          //   shouldRevalidate: () => true,
          //   errorElement: () => {
          //     return <NotFound />;
          //   },
          // },
          {
            path: "/settings/*",
            element: <General />,
            loader: generalDetailsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/general",
            element: <General />,
            loader: generalDetailsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/locations",
            element: <Locations />,
            loader: locationLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/billing",
            element: <Billing />,
            loader: billingDetailsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/locations/new/:pharmacyId",
            element: <LocationsAddNew />,
            loader: locationAddNewLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/locations/update/:pharmacyId",
            element: <LocationsUpdate />,
            loader: locationUpdateNewLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/*",
            element: <Teams />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/members",
            element: <Members />,
            loader: membersLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/members/new",
            element: <MembersAddNew />,
            loader: memberAddNewLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/members/:memberId",
            element: <MembersUpdate />,
            loader: memberByIdLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/roles",
            element: <Roles />,
            loader: rolesAndPermissionsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/roles/:roleId",
            element: <UpdateRole />,
            loader: rolesByIdLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/roles/new",
            element: <RolesAddNew />,
            loader: rolesAddNewLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/services",
            element: <Services />,
          },
          {
            path: "/settings/services/types",
            element: <ServiceTypes />,
            loader: typeLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/services/types/new",
            element: <TypesAddNew />,
            loader: typeAddNewLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/services/types/:serviceId",
            element: <TypesUpdate />,
            loader: typeByServiceIdLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/teams/templates",
            element: <Templates />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/templates/consultation",
            element: <CustomTemplate />,
            loader: consultationLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/templates/consultation/new",
            element: <AddNewCustomTemplate />,
            loader: addConsultationLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/templates/aiconsultation",
            element: <CustomAiTemplate />,
            loader: aiConsultationLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/templates/aiconsultation/new",
            element: <AddNewAiCustomTemplate />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/templates/aiconsultation/update/:templateId",
            element: <UpdateAiCustomTemplate />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/communication/messagetemplate",
            element: <EmailAndSms />,
            loader: emailsAndSmsTemplatesLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/communication/messagetemplate/new",
            element: <AddTemplate />,
            // loader: rolesAndPermissionsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/settings/communication/messagetemplate/update",
            element: <UpdateEmailTemplate />,
            // loader: rolesAndPermissionsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbit",
            element: <Orbit root={root} />,
            loader: orbitDashboardLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/nmsconsent/:serviceId",
            element: <NmsConsent />,
            loader: consentFormLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/NewMedicineService",
            element: <NewMedicineService />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/Abort",
            element: <Abort />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/moreInfo",
            element: <MoreInfo />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/personalInfo",
            element: <PersonalInfo />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/makeBooking",
            element: <MakeBooking />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/successPage",
            element: <SuccessPage />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "*",
            element: <NotFound />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/professionaldetails",
            element: <ProfessionalDetails />,
            loader: OrbitSettingsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/compliancedocuments",
            element: <ComplianceDocuments />,
            loader: OrbitSettingsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/accreditationsskills",
            element: <AccreditationsSkills />,
            loader: OrbitSettingsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/availability",
            element: <Availability />,
            loader: OrbitSettingsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/changepassword",
            element: <ChangePassword />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/orbitsettings/paymentdetails",
            element: <PaymentDetails />,
            loader: OrbitSettingsLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/useronboarding/success",
            element: <Success />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/useronboarding/success",
            element: <Success />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/onboardingverification",
            element: <OnboardingVerification root={root} />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/invitemembers",
            element: <InviteMembers root={root} />,
            loader: dashboardLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/usersignup/:code",
            element: <SignUp root={root} />,
            loader: signupLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/usersignup/:code/:IsMultipleInvite",
            element: <NotFound />,
            loader: multipleInviteLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/useronboarding/verificationemail",
            element: <VerificationEmail />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/onboardingResetPassword/onboardingResetPassword",
            element: <OnboardingResetPassword />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/neworganization",
            element: <DifferentOrganization />,
            loader: differentOrganizationLoader,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/selectionScreen",
            element: <SelectionScreen />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/companyselection",
            element: <Login root={root} signout={signout} />,
            shouldRevalidate: () => false,
            loader: companySelectionLoader,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/consultationForm",
            element: <ConsultationForm />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          {
            path: "/serviceConsultation",
            element: <ServiceConsultation />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
          },
          // {
          //   path: "/pharmacy/schedule/:pharmacyId",
          //   element: <BookingScheduler />,
          //   shouldRevalidate: () => false,
          //   errorElement: () => {
          //     return <NotFound />;
          //   },
          // },
          {
            path: "/pharmacy",
            element: <GlobalTabbedContentView />,
            shouldRevalidate: () => false,
            errorElement: () => {
              return <NotFound />;
            },
            children: [
              {
                path: "overview/:pharmacyId",
                element: <PharmacyOverviewPanel />,
              },
              {
                path: "services/:pharmacyId",
                element: <PharmacyServicesPanel />,
                loader: pharmacyServicesTabLoader,
              },
              {
                path: "workload/:pharmacyId",
                element: <ServicesWorkLoad />,
              },
              // {
              //   path: "schedule/:pharmacyId",
              //   element: <BookingScheduler />,
              //   loader: scheduleEventsLoader,
              // },
              {
                path: "schedule/:pharmacyId",
                element: <SchedulerComponent />,
                loader: scheduleEventsLoader,
              },
              {
                path: "schedule-new/:pharmacyId",
                element: <ScheduleCalendar />,
                loader: scheduleEventsLoader,
              },
              {
                path: "clinicalchecks/:pharmacyId",
                element: <ClinicalChecksKanban />,
                loader: clinicalCheckTabLoader,
              },
              {
                path: "patientdashboard/:pharmacyId/:patientId",
                element: <PatientDashboard />,
                loader: patientDashboardLoader,
              },
              {
                path:
                  "patientconsultation/:pharmacyId/:patientId/:consultationId",
                element: <PatientConsultation />,
                loader: patientConsultationsLoader,
              },

              {
                path: "patientlist/:pharmacyId",
                element: <PatientList />,
                loader: patientListViewLoader,
                shouldRevalidate: ({ currentParams, nextParams }) => {
                  // Revalidate when pharmacy ID changes
                  return currentParams.pharmacyId !== nextParams.pharmacyId;
                },
              },
              {
                path: "prescriptionapproval/:pharmacyId",
                element: <PrescriptionApproval />,
                loader: patientApprovalLoader,
              },
              {
                path: "patientdashboard-v2/:pharmacyId/:patientId",
                element: <PatientDashboardV2 />,
                loader: patientDashboardV2Loader,
              },
              {
                path: "dashboard/:pharmacyId",
                element: <PharmacyDashboard />,
                loader: pharmacyDashboardLoader,
              },
              {
                path: "documents/:pharmacyId",
                element: <Documents />,
                loader: companyDocumentsLoader,
              },
              {
                path: "analytics/:pharmacyId",
                element: <Analytics />,
                loader: AnalyticsLoader,
              },
              {
                path: "titan/:pharmacyId",
                element: <TitanScreen />,
                loader: titanTabLoader,
              },
            ],
          },
        ],
      },
    ];

    return customRoutes;
  };
  // #endregion

  // #region Return Object

  return {
    auth,
    appState,
    pharmacyServiceState,
    nmsServiceState,
    documentState,
    clincicalChecksState,
    orbitState,
    generalsState,
    memberState,
    billingState,
    locationState,
    consentState,
    onboardingVerificationState,
    scheduleEventState,
    pharmacyDashboardState,
    reportingState,
    patientState,
    templateState,
    marketAppState,
    treatmentPlanState,
    dashboardLoader,
    pharmacyServicesTabLoader,
    rolesAndPermissionsLoader,
    getClinicalChecksLoader,
    orbitDashboardLoader,
    signout,
    loadRoutes,
    getAuthToken,
    generalDetailsLoader,
    NmsLoader,
    getTimelineDataForClinicalServiceId,
    patientPrescriptionState,
    companyDocumentState,
    companyServiceBillingState,
    patientCommunicationState,
    analyticsState,
    pharmacyDashboardLoader,
    pharmacyNotificationsState,
    dosState,
    dashboardKPIState,
    titanTabState,
    titanTabLoader,
    accountExpired,
    setAccountExpired,
    accountExpiredReason,
    mysClaimsState,
  };
  // #endregion
};
export { store };
export default useTitanApp;
